import { useEffect, useState, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import BootstrapSlider from "bootstrap-slider";
import Footer from "./Footer";
import Header from "./Header";
import Ico1 from "./assets/img/ico-1.png";
import IcoActive1 from "./assets/img/icoActive-1.png";
import Ico2 from "./assets/img/ico-2.png";
import IcoActive2 from "./assets/img/icoActive-2.png";
import Ico3 from "./assets/img/ico-3.png";
import IcoActive3 from "./assets/img/icoActive-3.png";
import PlaneIco from "./assets/img/PlaneIco.png";
import EarlyMorning from "./assets/img/EarlyMorning.png";
import MorningIco from "./assets/img/Morning.png";
import AfternoonIco from "./assets/img/Afternoon.png";
import EveningIco from "./assets/img/Evening.png";
import airlineImg from "./assets/img/airlineImg.png";
import PlaneIco2 from "./assets/img/PlaneIco-2.png";
import PlaneIco3 from "./assets/img/PlaneIco-3.png";
import StopPlaneImg from "./assets/img/stopPlane.png";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { searchTwoWayFlights, convertCurrency } from "../services/services";
import {
  formatDateWithWeekday,
  formatTime,
  calculateDuration,
  calculateLayover,
} from "./formatDateWithWeekday";

const API_URL =
  "https://raw.githubusercontent.com/mwgg/Airports/master/airports.json";
const DepartureReturnFlighs = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [dates, setDates] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  const [initialSlide, setInitialSlide] = useState(0);
  const [isClosed, setIsClosed] = useState(false);
  const sliderRef = useRef(null);
  const [activeTab, setActiveTab] = useState("tab1");
  const [isPanelVisible, setIsPanelVisible] = useState(false);

  const [fromLocation, setFromLocation] = useState("");
  const [toLocation, setToLocation] = useState("");
  const [showFromDropdown, setShowFromDropdown] = useState(false);
  const [showToDropdown, setShowToDropdown] = useState(false);
  const [seatClass, setSeatClass] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [passengerDropdownVisible, setPassengerDropdownVisible] =
    useState(false);
  const [passengerCounts, setPassengerCounts] = useState({
    adults: 0,
    children: 0,
    infants: 0,
  });
  const [journeyType, setJourneyType] = useState(1); // 1: One-way, 2: Round-trip
  const [childrenAges, setChildrenAges] = useState([]);
  const [selectedFromIATA, setSelectedFromIATA] = useState(""); // Stores IATA for From
  const [selectedToIATA, setSelectedToIATA] = useState(""); // Stores IATA for To
  const [departureDate, setDepartureDate] = useState("");
  const [returnDate, setReturnDate] = useState("");
  const [airports, setAirports] = useState([]);
  const [filteredFromOptions, setFilteredFromOptions] = useState([]);
  const [filteredToOptions, setFilteredToOptions] = useState([]);
  //const [isRoundTrip, setIsRoundTrip] = useState(false);
  const [minReturnDate, setMinReturnDate] = useState(null);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFlight, setSelectedFlight] = useState("");
  const [selectedReturnFlight, setSelectedReturnFlight] = useState(null);
  const [convertedPrices, setConvertedPrices] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(
    localStorage.getItem("preferredCurrency") || "MYR"
  );
  const [activeSort, setActiveSort] = useState("recommended");
  const [isRoundTrip, setIsRoundTrip] = useState(false);
  const [departureFlights, setDepartureFlights] = useState([]);
  const [returnFlights, setReturnFlights] = useState([]);
  const [departureSort, setDepartureSort] = useState("recommended");
  const [returnSort, setReturnSort] = useState("recommended");
  const [prevValidCount, setPrevValidCount] = useState(0);
  const [childAgeError, setChildAgeError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [priceCache, setPriceCache] = useState({});
  const [convertedPriceCache, setConvertedPriceCache] = useState({});
  const [loadingDates, setLoadingDates] = useState([]);
  const pendingRequests = useRef({});

  const [departurePriceCache, setDeparturePriceCache] = useState({});
  const [returnPriceCache, setReturnPriceCache] = useState({});
  const [convertedDeparturePriceCache, setConvertedDeparturePriceCache] =
    useState({});
  const [convertedReturnPriceCache, setConvertedReturnPriceCache] = useState(
    {}
  );
  const [loadingDepartureDates, setLoadingDepartureDates] = useState([]);
  const [loadingReturnDates, setLoadingReturnDates] = useState([]);
  const pendingDepartureRequests = useRef({});
  const pendingReturnRequests = useRef({});
  const [departureDates, setDepartureDates] = useState([]);
  const [returnDates, setReturnDates] = useState([]);
  const [departureActiveIndex, setDepartureActiveIndex] = useState(0);
  const [returnActiveIndex, setReturnActiveIndex] = useState(0);

  useEffect(() => {
    const storedData = localStorage.getItem("flightSearchData");
    console.log(storedData);
    if (storedData) {
      const {
        fromLocation: storedFromLocation,
        toLocation: storedToLocation,
        departureDate: storedDepartureDate,
        returnDate: storedReturnDate,
        passengerCounts: storedPassengerCounts,
        seatClass: storedSeatClass,
        isRoundTrip: storedIsRoundTrip,
      } = JSON.parse(storedData);

      if (storedFromLocation) {
        setFromLocation(storedFromLocation);
        const fromMatch = storedFromLocation.match(/\(([^)]+)\)/);
        if (fromMatch && fromMatch[1]) {
          setSelectedFromIATA(fromMatch[1]);
        }
      } else {
        setFromLocation(""); // Or null
        setSelectedFromIATA("");
      }

      if (storedToLocation) {
        setToLocation(storedToLocation);
        const toMatch = storedToLocation.match(/\(([^)]+)\)/);
        if (toMatch && toMatch[1]) {
          setSelectedToIATA(toMatch[1]);
        }
      } else {
        setToLocation(""); // Or null
        setSelectedToIATA("");
      }

      if (storedDepartureDate) setDepartureDate(storedDepartureDate);
      if (storedReturnDate) setReturnDate(storedReturnDate);
      if (storedPassengerCounts) setPassengerCounts(storedPassengerCounts);
      if (storedSeatClass) setSeatClass(storedSeatClass);
      if (storedIsRoundTrip !== undefined) setIsRoundTrip(storedIsRoundTrip);

      // Set the active button based on stored isRoundTrip
      const oneWayButton = document.querySelector(
        ".topCtaWrap .btn:not(.active)"
      );
      const roundTripButton = document.querySelector(".topCtaWrap .btn.active");

      if (storedIsRoundTrip && oneWayButton) {
        oneWayButton.classList.remove("active");
        if (roundTripButton) roundTripButton.classList.add("active");
      } else if (!storedIsRoundTrip && roundTripButton) {
        roundTripButton.classList.remove("active");
        if (oneWayButton) oneWayButton.classList.add("active");
      }

      // optional: clear after setting if you don't need it anymore
      // localStorage.removeItem("flightSearchData");
    } else {
      // Initialize if no data in localStorage
      setFromLocation("");
      setToLocation("");
      setSelectedFromIATA("");
      setSelectedToIATA("");
    }
  }, []);
  const fromOptions = ["New York", "London", "Tokyo", "Paris"];
  const toOptions = ["Los Angeles", "Dubai", "Singapore", "Sydney"];
  const seatClassOptions = ["Economy", "Business", "First", "Premium Economy"];
  const flights = location.state?.flights || [];
  // Function to handle count increment/decrement
  const updateCount = (type, increment) => {
    setPassengerCounts((prevCounts) => {
      const newCount = Math.max(0, prevCounts[type] + increment);

      if (type === "children") {
        if (increment > 0) {
          setPrevValidCount(prevCounts.children);
        }

        setChildrenAges((prevAges) => {
          if (newCount > prevAges.length) {
            return [...prevAges, ...Array(newCount - prevAges.length).fill("")];
          } else if (newCount < prevAges.length) {
            setShowModal(true);
            return prevAges;
          }
          return prevAges.slice(0, newCount);
        });

        if (increment > 0) setShowModal(true);
      }

      return { ...prevCounts, [type]: newCount };
    });
  };

  const validateChildAge = (age) => {
    const numAge = parseInt(age, 10);
    return age !== "" && !isNaN(numAge) && numAge >= 2 && numAge <= 12;
  };
  const removeChild = (index) => {
    setChildrenAges((prevAges) => {
      const newAges = [...prevAges];
      newAges.splice(index, 1);
      return newAges;
    });

    // Decrease count by exactly 1
    setPassengerCounts((prev) => ({
      ...prev,
      children: Math.max(0, prev.children - 1),
    }));
  };

  const getDepartureSortInfo = (sortType) => {
    if (!departureFlights.length)
      return { price: "Loading...", duration: "Loading..." };

    const sorted = sortDepartureFlights(departureFlights, sortType);
    if (!sorted.length) return { price: "N/A", duration: "N/A" };

    const flightIndex = departureFlights.findIndex(
      (f) => f.UniqueTransID === sorted[0].UniqueTransID
    );
    const price =
      convertedPrices[flightIndex] !== undefined
        ? convertedPrices[flightIndex]
        : sorted[0].BookingComponent?.TotalPrice || "N/A";

    return {
      price: `${selectedCurrency} ${price}`,
      duration: sorted[0].Directions?.[0]?.[0]?.DirectionTotalTime || "N/A",
    };
  };

  const getReturnSortInfo = (sortType) => {
    if (!returnFlights.length)
      return { price: "Loading...", duration: "Loading..." };

    const sorted = sortReturnFlights(returnFlights, sortType);
    if (!sorted.length) return { price: "N/A", duration: "N/A" };

    const flightIndex = returnFlights.findIndex(
      (f) => f.UniqueTransID === sorted[0].UniqueTransID
    );
    const price =
      convertedPrices[flightIndex] !== undefined
        ? convertedPrices[flightIndex]
        : sorted[0].BookingComponent?.TotalPrice || "N/A";

    return {
      price: `${selectedCurrency} ${price}`,
      duration: sorted[0].Directions?.[1]?.[0]?.DirectionTotalTime || "N/A",
    };
  };
  // Generate display text for input
  const getDisplayText = () => {
    const { adults, children, infants } = passengerCounts;
    const parts = [
      adults > 0 ? `${adults} Adult${adults > 1 ? "s" : ""}` : "",
      children > 0 ? `${children} Child${children > 1 ? "ren" : ""}` : "",
      infants > 0 ? `${infants} Infant${infants > 1 ? "s" : ""}` : "",
    ].filter(Boolean);
    return parts.length > 0 ? parts.join(", ") : "Select Passengers";
  };

  // Reset counts to default
  const clearAll = () => {
    setPassengerCounts({ adults: 0, children: 0, infants: 0 });
  };

  const saveSelection = () => {
    setPassengerDropdownVisible(false); // Close the dropdown after saving
  };
  useEffect(() => {
    const fetchAirports = async () => {
      try {
        const response = await axios.get(API_URL);
        const airportData = response.data;

        const airportList = Object.values(airportData).filter(
          (airport) => airport.iata
        );
        setAirports(airportList);
      } catch (error) {
        console.error("Error fetching airports:", error);
      }
    };
    fetchAirports();
  }, []);

  const handleFromLocationChange = (e) => {
    const inputValue = e.target.value;
    setFromLocation(inputValue);

    if (inputValue.length > 1) {
      const filtered = airports.filter(
        (airport) =>
          airport.city.toLowerCase().includes(inputValue.toLowerCase()) ||
          airport.iata.toLowerCase().includes(inputValue.toLowerCase())
      );
      setFilteredFromOptions(filtered);
      setShowFromDropdown(true);
    } else {
      setShowFromDropdown(false);
    }
  };

  const handleToLocationChange = (e) => {
    const inputValue = e.target.value;
    setToLocation(inputValue);

    if (inputValue.length > 1) {
      const filtered = airports.filter(
        (airport) =>
          airport.city.toLowerCase().includes(inputValue.toLowerCase()) ||
          airport.iata.toLowerCase().includes(inputValue.toLowerCase())
      );
      setFilteredToOptions(filtered);
      setShowToDropdown(true);
    } else {
      setShowToDropdown(false);
    }
  };

  useEffect(() => {
    if (location.state?.flights) {
      const allFlights = location.state.flights;

      const departure = allFlights.filter((flight) => flight.Directions?.[0]);
      const returns = allFlights.filter((flight) => flight.Directions?.[1]);

      setDepartureFlights(sortDepartureFlights(departure, departureSort));
      setReturnFlights(sortReturnFlights(returns, returnSort));

      console.log(
        "Sorted departure:",
        sortDepartureFlights(departure, departureSort)
      );
      console.log("Sorted return:", sortReturnFlights(returns, returnSort));
    }
  }, [location.state?.flights, departureSort, returnSort]);

  const sortDepartureFlights = (flights, sortType, isReturn = false) => {
    if (!flights || flights.length === 0) return [];

    const directionIndex = isReturn ? 1 : 0;
    const sortedFlights = [...flights];

    sortedFlights.sort((a, b) => {
      const directionA = a.Directions?.[directionIndex]?.[0];
      const directionB = b.Directions?.[directionIndex]?.[0];
      if (!directionA || !directionB) return 0;

      const priceA = a.BookingComponent?.TotalPrice || 0;
      const priceB = b.BookingComponent?.TotalPrice || 0;

      const durationToMinutes = (duration) => {
        if (!duration) return 0;
        const parts = duration.split(" ");
        let total = 0;
        parts.forEach((part) => {
          if (part.includes("h")) {
            total += parseInt(part.replace("h", "")) * 60;
          } else if (part.includes("m")) {
            total += parseInt(part.replace("m", ""));
          }
        });
        return total;
      };

      const durationA = durationToMinutes(directionA.DirectionTotalTime);
      const durationB = durationToMinutes(directionB.DirectionTotalTime);

      switch (sortType) {
        case "fastest":
          return durationA - durationB;
        case "cheapest":
          return priceA - priceB;
        case "recommended":
        default:
          const maxPrice = Math.max(
            ...sortedFlights.map((f) => f.BookingComponent?.TotalPrice || 0)
          );
          const maxDuration =
            Math.max(
              ...sortedFlights.map((f) =>
                durationToMinutes(
                  f.Directions?.[directionIndex]?.[0]?.DirectionTotalTime ||
                    "0h 0m"
                )
              )
            ) || 1;

          const normalizedPriceA = maxPrice > 0 ? priceA / maxPrice : 0;
          const normalizedPriceB = maxPrice > 0 ? priceB / maxPrice : 0;
          const normalizedDurationA =
            maxDuration > 0 ? durationA / maxDuration : 0;
          const normalizedDurationB =
            maxDuration > 0 ? durationB / maxDuration : 0;

          const scoreA =
            0.6 * normalizedPriceA + 0.4 * (1 - normalizedDurationA);
          const scoreB =
            0.6 * normalizedPriceB + 0.4 * (1 - normalizedDurationB);

          return scoreA - scoreB;
      }
    });

    return sortedFlights;
  };
  const sortReturnFlights = (flights, sortType, isReturn = false) => {
    if (!flights || flights.length === 0) return [];

    const sortedFlights = [...flights];
    const directionIndex = isReturn ? 1 : 0;

    sortedFlights.sort((a, b) => {
      const directionA = a.Directions?.[directionIndex]?.[0];
      const directionB = b.Directions?.[directionIndex]?.[0];

      const priceA = a.BookingComponent?.TotalPrice || 0;
      const priceB = b.BookingComponent?.TotalPrice || 0;

      if (!directionA || !directionB) return 0;

      const durationToMinutes = (duration) => {
        if (!duration) return 0;
        const parts = duration.split(" ");
        let total = 0;
        parts.forEach((part) => {
          if (part.includes("h")) {
            total += parseInt(part.replace("h", "")) * 60;
          } else if (part.includes("m")) {
            total += parseInt(part.replace("m", ""));
          }
        });
        return total;
      };

      const durationA = durationToMinutes(directionA.DirectionTotalTime);
      const durationB = durationToMinutes(directionB.DirectionTotalTime);

      switch (sortType) {
        case "fastest":
          return durationA - durationB;
        case "cheapest":
          return priceA - priceB;
        case "recommended":
        default:
          // Calculate a weighted score (60% price, 40% duration)
          const maxPrice = Math.max(
            ...sortedFlights.map((f) => f.BookingComponent?.TotalPrice || 0)
          );
          const maxDuration = Math.max(
            ...(sortedFlights.map((f) =>
              durationToMinutes(
                f.Directions?.[directionIndex]?.[0]?.DirectionTotalTime ||
                  "0h 0m"
              )
            ) || 1)
          );

          const normalizedPriceA = maxPrice > 0 ? priceA / maxPrice : 0;
          const normalizedPriceB = maxPrice > 0 ? priceB / maxPrice : 0;
          const normalizedDurationA =
            maxDuration > 0 ? durationA / maxDuration : 0;
          const normalizedDurationB =
            maxDuration > 0 ? durationB / maxDuration : 0;

          const scoreA =
            0.6 * normalizedPriceA + 0.4 * (1 - normalizedDurationA);
          const scoreB =
            0.6 * normalizedPriceB + 0.4 * (1 - normalizedDurationB);

          return scoreA - scoreB;
      }
    });

    return sortedFlights;
  };
  const handleDepartureSortChange = (sortType) => {
    console.log("Setting departure sort to:", sortType);
    setDepartureSort(sortType);
    setDepartureFlights((prev) => sortDepartureFlights(prev, sortType));
  };

  const handleReturnSortChange = (sortType) => {
    console.log("Setting return sort to:", sortType);
    setReturnSort(sortType);
    setReturnFlights((prev) => sortReturnFlights(prev, sortType));
  };

  const handleSelectFromLocation = (airport) => {
    setFromLocation(`${airport.city} (${airport.iata})`);
    setSelectedFromIATA(airport.iata);
    setShowFromDropdown(false);
  };

  const handleSelectToLocation = (airport) => {
    setToLocation(`${airport.city} (${airport.iata})`);
    setSelectedToIATA(airport.iata);
    setShowToDropdown(false);
  };

  const renderFlightSegment = (direction, isReturn = false) => {
    const segments = direction?.Segments || [];
    const stops = segments.length - 1;
    const layovers = [];

    for (let i = 0; i < segments.length - 1; i++) {
      const arrival = new Date(segments[i].Arrival);
      const departure = new Date(segments[i + 1].Departure);
      layovers.push(calculateLayover(arrival, departure));
    }

    return (
      <div className="items">
        <h3>{segments[0].Departure.split(" ")[1].slice(0, 5)}</h3>
        <p>{getCityByIata(direction.Origin)}</p>
        <p>{direction.Origin}</p>

        <h4>{direction.DirectionTotalTime}</h4>

        <div className="planeIcoWrap">
          {stops === 0 ? (
            <img src={PlaneIco} className="img-fluid" alt="" />
          ) : (
            <div className="stop-dots">
              {Array(stops)
                .fill()
                .map((_, i) => (
                  <div key={i} className="stop-dot">
                    <img src={StopPlaneImg} className="img-fluid" alt="" />
                    <div className="stop-info">
                      {getCityByIata(segments[i].Destination)} (
                      {segments[i].Destination})
                      <br />
                      Layover: {layovers[i]}
                    </div>
                  </div>
                ))}
            </div>
          )}
        </div>

        <h3>
          {segments[segments.length - 1].Arrival.split(" ")[1].slice(0, 5)}
        </h3>
        <p>{getCityByIata(direction.Destination)}</p>
        <p>{direction.Destination}</p>
      </div>
    );
  };
  const handleChildAgeChange = (index, value) => {
    setChildrenAges((prevAges) => {
      const updatedAges = [...prevAges];
      updatedAges[index] = value;
      return updatedAges;
    });
  };
  const renderFlightCard = (flight, index, isReturn = false) => {
    const directionIndex = isReturn ? 1 : 0;
    const direction = flight.Directions?.[directionIndex]?.[0];
    if (!direction) return null;

    const segments = direction.Segments;
    const bookingInfo = flight.BookingComponent;
    const isSelected = isReturn
      ? selectedReturnFlight?.index === index
      : selectedFlight?.index === index;

    return (
      <li key={`${isReturn ? "return-" : "departure-"}${flight.UniqueTransID}`}>
        <div className={`itemWrap ${isSelected ? "selected" : ""}`}>
          <div className="topWrap">
            <div className="leftWrap">
              <div className="icoWrap">
                <img src={airlineImg} className="img-fluid" alt="" />
              </div>
              <h2>{direction.PlatingCarrierName}</h2>
            </div>
            <div className="midSecWrap">
              <div className="leftWrap">
                <span>{formatDateWithWeekday(segments[0].Departure)}</span>
                <ul>
                  <li>{renderFlightSegment(direction, isReturn)}</li>
                </ul>
              </div>
              <div className="rightWrap">
                <p>
                  Travel Class: <span>{segments[0].ServiceClass}</span>
                </p>
                <h2>${bookingInfo.TotalPrice}</h2>
                <button
                  className={`btnBook ${isSelected ? "selected" : ""}`}
                  onClick={() => {
                    if (isReturn) {
                      setSelectedReturnFlight(
                        isSelected ? null : { ...flight, index }
                      );
                    } else {
                      setSelectedFlight(
                        isSelected ? null : { ...flight, index }
                      );
                    }
                  }}
                >
                  {isSelected ? "Selected" : "Select"}
                </button>
              </div>
            </div>
          </div>
          <div className="btmWrap">
            {/* <p>{segments[0].BookingCount} seats remaining</p> */}
            <p className="clrTxt">
              {flight.Refundable ? "Refundable" : "Non-Refundable"}
            </p>
            <Link to="" className="clrTxt weightTxt">
              View flight details
            </Link>
          </div>
        </div>
      </li>
    );
  };

  const validateForm = () => {
    const newErrors = {};
    if (!fromLocation) {
      newErrors.fromLocation = "Please select departure airport";
    }

    if (!toLocation) {
      newErrors.toLocation = "Please select arrival airport";
    } else if (
      fromLocation &&
      toLocation &&
      selectedFromIATA === selectedToIATA
    ) {
      newErrors.toLocation = "Arrival airport cannot be same as departure";
    }

    if (!departureDate) {
      newErrors.departureDate = "Please select departure date";
    } else if (new Date(departureDate) < new Date().setHours(0, 0, 0, 0)) {
      newErrors.departureDate = "Departure date cannot be in the past";
    }

    if (isRoundTrip) {
      if (!returnDate) {
        newErrors.returnDate = "Please select return date";
      } else if (new Date(returnDate) < new Date(departureDate)) {
        newErrors.returnDate = "Return date must be after departure date";
      }
    }

    if (passengerCounts.adults < 1) {
      newErrors.passengers = "At least 1 adult is required";
    } else if (passengerCounts.infants > passengerCounts.adults) {
      newErrors.passengers = "Cannot have more infants than adults";
    }

    // Seat class validation
    if (!seatClass) {
      newErrors.seatClass = "Please select seat class";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSearchFlights = async () => {
    if (!validateForm()) {
      return;
    }
    // const { Departure, Return } = await searchTwoWayFlights(searchData);
    setDepartureFlights([]);
    setReturnFlights([]);
    setIsLoading(true);
    // Prepare data payload
    const requestData = {
      adults: passengerCounts.adults,
      childs: passengerCounts.children,
      infants: passengerCounts.infants,
      journeyType: isRoundTrip ? 2 : 1,
      class: seatClass,
      preferredCarriers: [],
      childrenAges: childrenAges,
      fare_type: "1",
      routes: [
        {
          origin: selectedFromIATA,
          destination: selectedToIATA,
          departureDate: departureDate,
        },
      ],
    };
    if (isRoundTrip) {
      requestData.routes.push({
        origin: selectedToIATA,
        destination: selectedFromIATA,
        departureDate: returnDate,
      });
    }
    console.log(journeyType + "_________frome Hone");

    console.log("Request Payload:", requestData); // Debugging

    const searchData = {
      fromLocation: fromLocation,
      toLocation: toLocation,
      departureDate: departureDate,
      returnDate: returnDate,
      passengerCounts: {
        adults: passengerCounts.adults,
        children: passengerCounts.children,
        infants: passengerCounts.infants,
      },
      seatClass: seatClass,
      isRoundTrip: isRoundTrip,
      journeyType: isRoundTrip ? 2 : 1,
    };

    localStorage.setItem("flightSearchData", JSON.stringify(searchData));
    await searchTwoWayFlights(
      requestData,
      (response) => {
        console.log("Flight Search Successful:", response);
        setIsLoading(false);
        if (isRoundTrip) {
          // Navigate to DepartureReturnFlights for round trips
          navigate("/DepartureReturnFlighs", {
            state: {
              flights: response.data.AirSearchResponses,
              searchData: searchData,
              currency: response.data.Currency,
            },
          });
        } else {
          // Navigate to FlightList for one-way trips
          navigate("/FlightList", {
            state: {
              flights: response.data.AirSearchResponses,
              searchData: searchData,
            },
          });
        }
      },
      (error) => {
        setIsLoading(false);
        console.error("Error searching flights:", error);
        alert("Failed to search flights. Please try again.");
      }
    );
  };
  console.log("Flight ID:", flights.UniqueTransID);
  console.log("Selected ID:", selectedFlight?.UniqueTransID);
  const calculateLayovers = (segments) => {
    const layovers = [];
    for (let i = 0; i < segments.length - 1; i++) {
      const arrival = new Date(segments[i].Arrival);
      const departure = new Date(segments[i + 1].Departure);
      const layoverMs = departure - arrival;
      const hours = Math.floor(layoverMs / (1000 * 60 * 60));
      const minutes = Math.floor((layoverMs % (1000 * 60 * 60)) / (1000 * 60));
      layovers.push(`${hours}h ${minutes}m`);
    }
    return layovers;
  };

  // Success callback
  const onSuccess = (response) => {
    setIsLoading(false);
    console.log("Flight Search Successful:", response);
    // Navigate to FlightList and pass response data
    if (isRoundTrip) {
      navigate("/DepartureReturnFlighs", {
        state: {
          flights: response.data.AirSearchResponses,
          currency: response.data.Currency,
        },
      });
    } else {
      navigate("/FlightList", {
        state: {
          flights: response.data.AirSearchResponses,
          currency: response.data.Currency,
        },
        state: {
          flights: response.data.AirSearchResponses,
          currency: response.data.Currency,
        },
      });
    }
  };

  // Error callback
  const onError = (error) => {
    setIsLoading(false);
    console.error("Error searching flights:", error);
    alert("Failed to search flights. Please try again.");
  };

  // useEffect(() => {
  //     const convertPrices = async () => {
  //       const newConvertedPrices = {};

  //       for (const [date, priceData] of Object.entries(priceCache)) {
  //         if (priceData && priceData.price && priceData.currency) {
  //           if (priceData.currency === selectedCurrency) {
  //             newConvertedPrices[date] = priceData.price;
  //           } else {
  //             try {
  //               const convertedPrice = await convertCurrency(
  //                 priceData.price,
  //                 priceData.currency,
  //                 selectedCurrency
  //               );
  //               newConvertedPrices[date] = convertedPrice;
  //             } catch (error) {
  //               console.error(`Error converting price for ${date}:`, error);
  //               newConvertedPrices[date] = priceData.price;
  //             }
  //           }
  //         }
  //       }

  //       setConvertedPriceCache(newConvertedPrices);

  //       setDates(prevDates =>
  //         prevDates.map(date => ({
  //           ...date,
  //           price: newConvertedPrices[date.formattedDate]
  //             ? `${selectedCurrency} ${newConvertedPrices[date.formattedDate]}`
  //             : date.price
  //         }))
  //       );
  //     };

  //     if (Object.keys(priceCache).length > 0) {
  //       convertPrices();
  //     }
  //   }, [selectedCurrency, priceCache]);

  // useEffect(() => {
  //   const today = new Date();
  //   const currentYear = today.getFullYear();
  //   const currentMonth = today.getMonth();
  //   const currentDate = today.getDate();
  //   const currentDayOfWeek = today.getDay();

  //   const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();

  //   const generatedDates = Array.from({ length: daysInMonth - currentDate + 1 }, (_, index) => {
  //     const day = currentDate + index;
  //     const dateObj = new Date(currentYear, currentMonth, day);
  //     const formattedDate = dateObj.toLocaleDateString('en-CA'); // 'YYYY-MM-DD'

  //     return {
  //       id: index,
  //       date: `${day < 10 ? "0" + day : day} ${today.toLocaleString("default", {
  //         month: "short",
  //       })} ${currentYear}`,
  //       dateObj,
  //       formattedDate,
  //       price: null,
  //       isActive: day === currentDate,
  //     };
  //   });

  //   setDates(generatedDates);
  //   const weekStartIndex = 0;
  //   setInitialSlide(weekStartIndex);
  // }, []);
  //   const handleFlightSearchResponse = (date, response) => {
  //     if (!response?.data?.AirSearchResponses) {
  //       return { price: 'N/A', currency: selectedCurrency };
  //     }

  //     // Get the minimum price from MinMaxPrice
  //     const minPrice = response.data?.MinMaxPrice?.MinPrice;

  //     return minPrice ? {
  //       price: minPrice,
  //       currency: response.data.Currency || selectedCurrency
  //     } : { price: 'N/A', currency: selectedCurrency };
  // };

  // Add this function to handle flight search error
  // const handleFlightSearchError = (date, error) => {
  //   console.error(`Error fetching flights for ${date}:`, error);
  //   return 'Error';
  // };
  // const fetchPricesForDates = useCallback((datesToFetch) => {
  //   // Filter dates that need fetching
  //   const datesNeedingFetch = datesToFetch.filter(date =>
  //     (!priceCache[date.formattedDate] || priceCache[date.formattedDate].price === 'N/A') &&
  //     !loadingDates.includes(date.formattedDate) &&
  //     !pendingRequests.current[date.formattedDate]
  //   );

  //   if (datesNeedingFetch.length === 0) return;

  //   // Mark these dates as loading
  //   setLoadingDates(prev => [...prev, ...datesNeedingFetch.map(d => d.formattedDate)]);

  //   datesNeedingFetch.forEach(date => {
  //     const requestData = {
  //       adults: 1,
  //       childs: 0,
  //       infants: 0,
  //       journeyType: 2,
  //       class: seatClass || "Economy",
  //       preferredCarriers: [],
  //       childrenAges: [],
  //       fare_type: "1",
  //       routes: [{
  //         origin: selectedFromIATA,
  //         destination: selectedToIATA,
  //         departureDate: date.formattedDate
  //       },
  //       {
  //         origin: selectedToIATA,
  //         destination: selectedFromIATA,
  //         departureDate: date.formattedDate
  //       }
  //     ]
  //     };

  //     // Store the request reference
  //     pendingRequests.current[date.formattedDate] = true;

  //     searchTwoWayFlights(
  //       requestData,
  //       (response) => {
  //         const priceData = handleFlightSearchResponse(date.formattedDate, response);

  //         // Update cache with original price and currency
  //         setPriceCache(prev => ({
  //           ...prev,
  //           [date.formattedDate]: priceData
  //         }));

  //         // Convert price if needed
  //         if (priceData.currency !== selectedCurrency && priceData.price !== 'N/A') {
  //           convertCurrency(
  //             priceData.price,
  //             priceData.currency,
  //             selectedCurrency
  //           ).then(convertedPrice => {
  //             setConvertedPriceCache(prev => ({
  //               ...prev,
  //               [date.formattedDate]: convertedPrice
  //             }));

  //             // Update dates with converted price
  //             setDates(prevDates =>
  //               prevDates.map(d =>
  //                 d.formattedDate === date.formattedDate
  //                   ? { ...d, price: `${selectedCurrency} ${convertedPrice}` }
  //                   : d
  //               )
  //             );
  //           }).catch(error => {
  //             console.error('Conversion error:', error);
  //             // Fallback to original price
  //             setDates(prevDates =>
  //               prevDates.map(d =>
  //                 d.formattedDate === date.formattedDate
  //                   ? { ...d, price: `${priceData.currency} ${priceData.price}` }
  //                   : d
  //               )
  //             );
  //           });
  //         } else {
  //           // No conversion needed
  //           setDates(prevDates =>
  //             prevDates.map(d =>
  //               d.formattedDate === date.formattedDate
  //                 ? { ...d, price: `${priceData.currency} ${priceData.price}` }
  //                 : d
  //             )
  //           );
  //         }

  //         // Clean up
  //         delete pendingRequests.current[date.formattedDate];
  //         setLoadingDates(prev => prev.filter(d => d !== date.formattedDate));
  //       },
  //       (error) => {
  //         const priceData = handleFlightSearchError(date.formattedDate, error);

  //         setPriceCache(prev => ({
  //           ...prev,
  //           [date.formattedDate]: priceData
  //         }));

  //         setDates(prevDates =>
  //           prevDates.map(d =>
  //             d.formattedDate === date.formattedDate
  //               ? { ...d, price: `${priceData.currency} ${priceData.price}` }
  //               : d
  //           )
  //         );

  //         delete pendingRequests.current[date.formattedDate];
  //         setLoadingDates(prev => prev.filter(d => d !== date.formattedDate));
  //       }
  //     );
  //   });
  // }, [selectedCurrency, priceCache, loadingDates, selectedFromIATA, selectedToIATA, seatClass]);

  // useEffect(() => {
  //   if (selectedFromIATA && selectedToIATA && dates.length > 0) {
  //     // Fetch prices for visible dates initially
  //     const visibleStart = Math.max(0, initialSlide - 3);
  //     const visibleEnd = Math.min(dates.length - 1, initialSlide + 3);
  //     const visibleDates = dates.slice(visibleStart, visibleEnd + 1);
  //     fetchPricesForDates(visibleDates);
  //   }
  // }, [selectedCurrency]);

  // const sliderSettings = {
  //   infinite: false,
  //   slidesToShow: 6,
  //   slidesToScroll: 1,
  //   arrows: true,
  //   initialSlide,
  //   responsive: [
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow: 5,
  //       },
  //     },
  //     {
  //       breakpoint: 800,
  //       settings: {
  //         slidesToShow: 4,
  //       },
  //     },
  //     {
  //       breakpoint: 600,
  //       settings: {
  //         slidesToShow: 3,
  //       },
  //     },
  //     {
  //       breakpoint: 480,
  //       settings: {
  //         slidesToShow: 2,
  //       },
  //     },
  //   ],
  //   beforeChange: (_, next) => {
  //     setActiveIndex(next);

  //     // Fetch prices from today onward
  //     const today = new Date().toISOString().split("T")[0];
  //     const upcomingDates = dates.filter(
  //       (date) => date.formattedDate >= today
  //     );

  //     //fetchPricesForDates(upcomingDates);
  //   },
  // };

  // const handleDateClick = (index) => {
  //   setActiveIndex(index);
  //   sliderRef.current.slickGoTo(index);

  //   // Also fetch price for clicked date if not already loaded
  //   const clickedDate = dates[index];
  //   if (!priceCache[clickedDate.formattedDate] && !loadingDates.includes(clickedDate.formattedDate)) {
  //     fetchPricesForDates([clickedDate]);
  //   }
  // };
  // useEffect(() => {
  //   if (flights.length > 0 && departureDate) {
  //     // Find the date in our dates array that matches the searched date
  //     const searchedDate = dates.find(d => d.formattedDate === departureDate);

  //     if (searchedDate && !priceCache[departureDate]) {
  //       // Fetch price for the searched date if not already loaded
  //       fetchPricesForDates([searchedDate]);
  //     }
  //   }
  // }, [flights, departureDate, dates, priceCache, fetchPricesForDates]);

  const handleToggle = () => {
    setIsClosed(!isClosed);
  };

  useEffect(() => {
    if (sliderRef.current) {
      const priceSlider = new BootstrapSlider(sliderRef.current, {
        min: 300,
        max: 1000,
        range: true,
        value: [300, 500],
        step: 10,
        tooltip_split: true,
        tooltip: "always",
        formatter: function (value) {
          return `$${value}`;
        },
      });
      priceSlider.on("change", (event) => {
        console.log("Slider value changed:", event.newValue);
      });
    }
  }, []);

  useEffect(() => {
    // Initialize Flatpickr separately for each field
    flatpickr("#departure-datepicker", {
      dateFormat: "Y-m-d",
      minDate: "today",
      allowInput: true,
      onChange: (selectedDates, dateStr) => {
        setDepartureDate(dateStr);
        if (isRoundTrip && selectedDates[0]) {
          const nextDay = new Date(selectedDates[0]);
          nextDay.setDate(nextDay.getDate());
          setMinReturnDate(nextDay);
          returnPicker.set("minDate", nextDay);

          if (returnDate && new Date(returnDate) < selectedDates[0]) {
            setReturnDate(null);
            returnPicker.clear();
          }
        }
      },
      locale: {
        firstDayOfWeek: 0,
        weekdays: {
          shorthand: ["S", "M", "T", "W", "T", "F", "S"],
          longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ],
        },
      },
    });

    const returnPicker = flatpickr("#return-datepicker", {
      dateFormat: "Y-m-d",
      minDate: minReturnDate || "today",
      allowInput: true,
      onChange: (selectedDates, dateStr) => setReturnDate(dateStr),
      locale: {
        firstDayOfWeek: 0,
        weekdays: {
          shorthand: ["S", "M", "T", "W", "T", "F", "S"],
          longhand: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday",
          ],
        },
      },
    });
    return () => {
      // departurePicker.destroy();
      // returnPicker.destroy();
    };
  }, [isRoundTrip, minReturnDate]);

  const getCityByIata = (iataCode) => {
    const airport = airports.find((airport) => airport.iata === iataCode);
    return airport ? airport.city : iataCode;
  };
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  // Update window width on resize
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleRightPanel = () => {
    setIsPanelVisible(!isPanelVisible);
  };

  const searchCurrency = location.state?.currency;
  // useEffect(() => {
  //   const convertPrices = async (priceCache, setConvertedCache) => {
  //     const newConverted = {};

  //     for (const [date, priceData] of Object.entries(priceCache)) {
  //       if (priceData?.price && priceData?.currency) {
  //         if (priceData.currency === selectedCurrency) {
  //           newConverted[date] = priceData.price;
  //         } else {
  //           try {
  //             const converted = await convertCurrency(priceData.price, priceData.currency, selectedCurrency);
  //             newConverted[date] = converted;
  //           } catch (e) {
  //             console.error(`Error converting price for ${date}`, e);
  //             newConverted[date] = priceData.price;
  //           }
  //         }
  //       }
  //     }

  //     setConvertedCache(newConverted);
  //   };

  //   if (Object.keys(departurePriceCache).length > 0) {
  //     convertPrices(departurePriceCache, setConvertedDeparturePriceCache);
  //   }
  //   if (Object.keys(returnPriceCache).length > 0) {
  //     convertPrices(returnPriceCache, setConvertedReturnPriceCache);
  //   }
  // }, [selectedCurrency, departurePriceCache, returnPriceCache]);

  useEffect(() => {
    const convertAllPrices = async () => {
      if (!flights.length || !searchCurrency) return;

      try {
        const promises = flights.map(async (flight) => {
          const total = flight.BookingComponent?.TotalPrice || 0;
          if (!total) return 0;

          const converted = await convertCurrency(
            total,
            searchCurrency,
            selectedCurrency
          );
          return converted || total; // Fallback to original price if conversion fails
        });

        const results = await Promise.all(promises);
        setConvertedPrices(results);
      } catch (error) {
        console.error("Error converting prices:", error);
        // Fallback to original prices
        setConvertedPrices(
          flights.map((f) => f.BookingComponent?.TotalPrice || 0)
        );
      }
    };

    convertAllPrices();
  }, [flights, searchCurrency, selectedCurrency]);
  const handleTripTypeChange = (isRound) => {
    setIsRoundTrip(isRound);
    if (!isRound) {
      setReturnDate(null);
      setMinReturnDate(null);
    } else if (departureDate) {
      const nextDay = new Date(departureDate);
      nextDay.setDate(nextDay.getDate());
      setMinReturnDate(nextDay);
    }
  };
  const handleSaveChildren = () => {
    const allValid = childrenAges.every((age) => validateChildAge(age));

    const hasEmptyNewChildren =
      passengerCounts.children > childrenAges.length &&
      childrenAges.some((age) => age === "");

    if (!allValid || hasEmptyNewChildren) {
      setChildAgeError("Please enter valid ages (2-12 years) for all children");
      return;
    }
    setChildAgeError("");
    setShowModal(false);
  };

  return (
    <>
      <Header></Header>
      <div className="mainContent depReturnFlightWrap">
        <div className={`topResFrm ${isClosed ? "closed" : ""}`}>
          <div className="topResFrmWrap">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="topCtaWrap">
                    <button
                      className={!isRoundTrip ? "btn active" : "btn"}
                      onClick={() => handleTripTypeChange(false)}
                    >
                      One-way
                    </button>
                    <button
                      className={isRoundTrip ? "btn active" : "btn"}
                      onClick={() => handleTripTypeChange(true)}
                    >
                      Round trip
                    </button>
                    {/* <button className="btn">Multi-city</button> */}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <form>
                    <ul className="formList">
                      <li className="sixth">
                        <div className="inputField">
                          <label>From</label>
                          <div className="icoInputWrap">
                            <div className="icoWrap">
                              <svg
                                width="33"
                                height="23"
                                viewBox="0 0 33 23"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M3.56495 14.1034C3.56409 14.1039 3.56315 14.1043 3.5622 14.1049C3.21622 14.2847 3.06595 14.7002 3.21725 15.0597C3.36898 15.4205 3.7727 15.6036 4.14403 15.48L14.613 11.9969L12.6555 15.1936C12.5133 15.4258 12.5433 15.7244 12.729 15.9236C12.9147 16.1228 13.2104 16.1738 13.4522 16.0481L15.5051 14.9814C15.564 14.9508 15.6175 14.9107 15.6635 14.8626L21.7451 8.50978L29.2507 4.59352C32.0932 3.06119 31.7639 1.88327 31.5953 1.55885C31.4646 1.30728 31.1724 0.969974 30.5232 0.79161C29.8646 0.610669 28.9749 0.625104 27.8036 0.835772C27.4126 0.906052 27.1968 0.900123 26.9683 0.893851C26.1649 0.871857 25.6199 0.925726 22.914 2.33176L8.11468 10.0226L2.37543 7.04404C2.15901 6.93174 1.90152 6.93183 1.68509 7.04438L0.718012 7.54699C0.518942 7.65044 0.37675 7.83765 0.330527 8.05717C0.284303 8.27677 0.338947 8.50548 0.479335 8.68032L4.46278 13.6419L3.56495 14.1034Z"
                                  fill="#000000"
                                />
                                <path
                                  d="M30.8194 20.1309H2.80156C2.01371 20.1309 1.375 20.7697 1.375 21.5574C1.375 22.3451 2.01371 22.984 2.80156 22.984H30.8194C31.6072 22.984 32.246 22.3453 32.246 21.5574C32.2459 20.7695 31.6072 20.1309 30.8194 20.1309Z"
                                  fill="#000000"
                                />
                              </svg>
                            </div>
                            <div className="dropdown dropdownHt">
                              <input
                                type="text"
                                id="from-location"
                                placeholder="Start typing City or Airport"
                                value={fromLocation}
                                required
                                onFocus={() => {
                                  setShowFromDropdown(true);
                                  setFilteredFromOptions(airports);
                                }}
                                onChange={handleFromLocationChange}
                              />
                              {errors.fromLocation && (
                                <span className="error">
                                  {errors.fromLocation}
                                </span>
                              )}
                              {showFromDropdown &&
                                filteredFromOptions.length > 0 && (
                                  <ul className="dropdown-menu">
                                    {filteredFromOptions.map(
                                      (airport, index) => (
                                        <li
                                          key={index}
                                          onClick={() =>
                                            handleSelectFromLocation(airport)
                                          }
                                          className={
                                            fromLocation ===
                                            `${airport.city} (${airport.iata})`
                                              ? "selected"
                                              : ""
                                          }
                                        >
                                          {airport.city} ({airport.iata})
                                        </li>
                                      )
                                    )}
                                  </ul>
                                )}
                            </div>
                          </div>
                        </div>
                      </li>
                      <li className="sixth">
                        <div className="inputField">
                          <label>To</label>
                          <div className="icoInputWrap">
                            <div className="icoWrap">
                              <svg
                                width="33"
                                height="24"
                                viewBox="0 0 33 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1.95755 7.53175C1.95649 7.53166 1.95552 7.53148 1.95437 7.5313C1.55853 7.46615 1.1786 7.7157 1.08163 8.10535C0.984214 8.49598 1.20397 8.89571 1.58602 9.02283L12.3572 12.6066L8.77421 14.0334C8.51397 14.1371 8.35468 14.4016 8.38491 14.68C8.41496 14.9585 8.6272 15.1828 8.9038 15.2283L11.2525 15.6149C11.32 15.6259 11.3887 15.6259 11.4562 15.6147L20.3821 14.1301L28.979 15.5304C32.2653 16.0203 32.7201 14.8472 32.7812 14.4758C32.8286 14.188 32.7959 13.7299 32.3709 13.1829C31.94 12.6278 31.198 12.0914 30.1034 11.5429C29.7378 11.3597 29.5638 11.2218 29.3796 11.0758C28.7313 10.5624 28.2489 10.2708 25.1534 9.76121L8.2212 6.9744L5.32937 0.983023C5.22029 0.75708 5.00814 0.598407 4.76045 0.557656L3.65398 0.37547C3.42618 0.337989 3.19361 0.404553 3.02035 0.556949C2.84692 0.709346 2.75092 0.931399 2.75887 1.16203L2.98208 7.70456L1.95755 7.53175Z"
                                  fill="#000000"
                                />
                                <path
                                  d="M31.1595 20.3496H2.33298C1.52238 20.3496 0.865234 21.0067 0.865234 21.8173C0.865234 22.6279 1.52238 23.285 2.33298 23.285H31.1595C31.9701 23.285 32.6274 22.6277 32.6274 21.8173C32.6274 21.0068 31.9701 20.3496 31.1595 20.3496Z"
                                  fill="#000000"
                                />
                              </svg>
                            </div>
                            <div className="dropdown dropdownHt">
                              <input
                                type="text"
                                id="to-location"
                                placeholder="Start typing City or Airport"
                                value={toLocation}
                                required
                                onFocus={() => {
                                  setShowToDropdown(true);
                                  setFilteredToOptions(airports); // Show all options initially
                                }}
                                onBlur={() =>
                                  setTimeout(
                                    () => setShowToDropdown(false),
                                    150
                                  )
                                }
                                onChange={handleToLocationChange}
                              />
                              {errors.toLocation && (
                                <span className="error">
                                  {errors.toLocation}
                                </span>
                              )}
                              {showToDropdown &&
                                filteredToOptions.length > 0 && (
                                  <ul className="dropdown-menu">
                                    {filteredToOptions.map((option, index) => (
                                      <li
                                        key={index}
                                        onClick={() =>
                                          handleSelectToLocation(option)
                                        }
                                        className={
                                          toLocation ===
                                          `${option.city} (${option.iata})`
                                            ? "selected"
                                            : ""
                                        }
                                      >
                                        {option.city} ({option.iata})
                                      </li>
                                    ))}
                                  </ul>
                                )}
                            </div>
                          </div>
                        </div>
                      </li>
                      <li className="sixth">
                        <div className="inputField">
                          <label>Departure Date</label>
                          <div className="icoInputWrap">
                            <div className="icoWrap">
                              <svg
                                width="30"
                                height="29"
                                viewBox="0 0 30 29"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M21.9336 17.2808C22.6684 17.2808 23.264 16.6851 23.264 15.9503C23.264 15.2155 22.6684 14.6198 21.9336 14.6198C21.1988 14.6198 20.6031 15.2155 20.6031 15.9503C20.6031 16.6851 21.1988 17.2808 21.9336 17.2808Z"
                                  fill="#000000"
                                />
                                <path
                                  d="M21.9336 22.6027C22.6684 22.6027 23.264 22.007 23.264 21.2722C23.264 20.5374 22.6684 19.9418 21.9336 19.9418C21.1988 19.9418 20.6031 20.5374 20.6031 21.2722C20.6031 22.007 21.1988 22.6027 21.9336 22.6027Z"
                                  fill="#000000"
                                />
                                <path
                                  d="M16.6117 15.9503C16.6117 16.6851 16.016 17.2808 15.2812 17.2808C14.5464 17.2808 13.9507 16.6851 13.9507 15.9503C13.9507 15.2155 14.5464 14.6198 15.2812 14.6198C16.016 14.6198 16.6117 15.2155 16.6117 15.9503Z"
                                  fill="#000000"
                                />
                                <path
                                  d="M16.6117 21.2722C16.6117 22.007 16.016 22.6027 15.2812 22.6027C14.5464 22.6027 13.9507 22.007 13.9507 21.2722C13.9507 20.5374 14.5464 19.9418 15.2812 19.9418C16.016 19.9418 16.6117 20.5374 16.6117 21.2722Z"
                                  fill="#000000"
                                />
                                <path
                                  d="M8.62877 17.2808C9.36358 17.2808 9.95925 16.6851 9.95925 15.9503C9.95925 15.2155 9.36358 14.6198 8.62877 14.6198C7.89397 14.6198 7.29829 15.2155 7.29829 15.9503C7.29829 16.6851 7.89397 17.2808 8.62877 17.2808Z"
                                  fill="#000000"
                                />
                                <path
                                  d="M8.62877 22.6027C9.36358 22.6027 9.95925 22.007 9.95925 21.2722C9.95925 20.5374 9.36358 19.9418 8.62877 19.9418C7.89397 19.9418 7.29829 20.5374 7.29829 21.2722C7.29829 22.007 7.89397 22.6027 8.62877 22.6027Z"
                                  fill="#000000"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M8.62877 0.982422C9.17988 0.982422 9.62663 1.42918 9.62663 1.98028V2.99506C10.5074 2.97812 11.4778 2.97813 12.545 2.97814H18.0172C19.0844 2.97813 20.0549 2.97812 20.9357 2.99506V1.98028C20.9357 1.42918 21.3825 0.982422 21.9336 0.982422C22.4847 0.982422 22.9314 1.42918 22.9314 1.98028V3.0807C23.2773 3.10707 23.6048 3.14022 23.9147 3.18188C25.4746 3.3916 26.7371 3.83348 27.7328 4.82916C28.7285 5.82484 29.1704 7.0874 29.3801 8.64728C29.5839 10.163 29.5838 12.0996 29.5838 14.5447V17.3559C29.5838 19.8009 29.5839 21.7377 29.3801 23.2533C29.1704 24.8132 28.7285 26.0758 27.7328 27.0715C26.7371 28.0672 25.4746 28.509 23.9147 28.7187C22.399 28.9225 20.4623 28.9225 18.0172 28.9225H12.5452C10.1001 28.9225 8.16335 28.9225 6.64766 28.7187C5.08778 28.509 3.82522 28.0672 2.82954 27.0715C1.83385 26.0758 1.39198 24.8132 1.18226 23.2533C0.978479 21.7376 0.978495 19.801 0.978516 17.3559V14.5448C0.978495 12.0997 0.978479 10.163 1.18226 8.64728C1.39198 7.0874 1.83385 5.82484 2.82954 4.82916C3.82522 3.83348 5.08778 3.3916 6.64766 3.18188C6.95756 3.14022 7.28507 3.10707 7.63091 3.0807V1.98028C7.63091 1.42918 8.07767 0.982422 8.62877 0.982422ZM6.91358 5.15981C5.575 5.33977 4.80379 5.67728 4.24072 6.24035C3.67765 6.80342 3.34015 7.57463 3.16018 8.91321C3.1297 9.1399 3.10422 9.37856 3.08291 9.63054H27.4794C27.4581 9.37856 27.4326 9.1399 27.4022 8.91321C27.2222 7.57463 26.8847 6.80342 26.3216 6.24035C25.7585 5.67728 24.9873 5.33977 23.6488 5.15981C22.2815 4.97598 20.4791 4.97386 17.9421 4.97386H12.6202C10.0832 4.97386 8.28087 4.97598 6.91358 5.15981ZM2.97424 14.6198C2.97424 13.4836 2.97466 12.4947 2.99165 11.6263H27.5707C27.5877 12.4947 27.5881 13.4836 27.5881 14.6198V17.2808C27.5881 19.8178 27.586 21.6201 27.4022 22.9874C27.2222 24.326 26.8847 25.0972 26.3216 25.6603C25.7585 26.2234 24.9873 26.5609 23.6488 26.7408C22.2815 26.9247 20.4791 26.9268 17.9421 26.9268H12.6202C10.0832 26.9268 8.28087 26.9247 6.91358 26.7408C5.575 26.5609 4.80379 26.2234 4.24072 25.6603C3.67765 25.0972 3.34015 24.326 3.16018 22.9874C2.97635 21.6201 2.97424 19.8178 2.97424 17.2808V14.6198Z"
                                  fill="#000000"
                                />
                              </svg>
                            </div>
                            <div className="datePickerWrap">
                              <input
                                id="departure-datepicker"
                                value={departureDate}
                                required
                                onChange={(e) =>
                                  setDepartureDate(e.target.value)
                                }
                                placeholder="Select Date"
                                type="text"
                              />
                              {errors.departureDate && (
                                <span className="error">
                                  {errors.departureDate}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </li>
                      {isRoundTrip && (
                        <li className="sixth">
                          <div className="inputField">
                            <label>Return Date</label>
                            <div className="icoInputWrap">
                              <div className="icoWrap">
                                <svg
                                  width="30"
                                  height="29"
                                  viewBox="0 0 30 29"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M21.9336 17.2808C22.6684 17.2808 23.264 16.6851 23.264 15.9503C23.264 15.2155 22.6684 14.6198 21.9336 14.6198C21.1988 14.6198 20.6031 15.2155 20.6031 15.9503C20.6031 16.6851 21.1988 17.2808 21.9336 17.2808Z"
                                    fill="#000000"
                                  />
                                  <path
                                    d="M21.9336 22.6027C22.6684 22.6027 23.264 22.007 23.264 21.2722C23.264 20.5374 22.6684 19.9418 21.9336 19.9418C21.1988 19.9418 20.6031 20.5374 20.6031 21.2722C20.6031 22.007 21.1988 22.6027 21.9336 22.6027Z"
                                    fill="#000000"
                                  />
                                  <path
                                    d="M16.6117 15.9503C16.6117 16.6851 16.016 17.2808 15.2812 17.2808C14.5464 17.2808 13.9507 16.6851 13.9507 15.9503C13.9507 15.2155 14.5464 14.6198 15.2812 14.6198C16.016 14.6198 16.6117 15.2155 16.6117 15.9503Z"
                                    fill="#000000"
                                  />
                                  <path
                                    d="M16.6117 21.2722C16.6117 22.007 16.016 22.6027 15.2812 22.6027C14.5464 22.6027 13.9507 22.007 13.9507 21.2722C13.9507 20.5374 14.5464 19.9418 15.2812 19.9418C16.016 19.9418 16.6117 20.5374 16.6117 21.2722Z"
                                    fill="#000000"
                                  />
                                  <path
                                    d="M8.62877 17.2808C9.36358 17.2808 9.95925 16.6851 9.95925 15.9503C9.95925 15.2155 9.36358 14.6198 8.62877 14.6198C7.89397 14.6198 7.29829 15.2155 7.29829 15.9503C7.29829 16.6851 7.89397 17.2808 8.62877 17.2808Z"
                                    fill="#000000"
                                  />
                                  <path
                                    d="M8.62877 22.6027C9.36358 22.6027 9.95925 22.007 9.95925 21.2722C9.95925 20.5374 9.36358 19.9418 8.62877 19.9418C7.89397 19.9418 7.29829 20.5374 7.29829 21.2722C7.29829 22.007 7.89397 22.6027 8.62877 22.6027Z"
                                    fill="#000000"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M8.62877 0.982422C9.17988 0.982422 9.62663 1.42918 9.62663 1.98028V2.99506C10.5074 2.97812 11.4778 2.97813 12.545 2.97814H18.0172C19.0844 2.97813 20.0549 2.97812 20.9357 2.99506V1.98028C20.9357 1.42918 21.3825 0.982422 21.9336 0.982422C22.4847 0.982422 22.9314 1.42918 22.9314 1.98028V3.0807C23.2773 3.10707 23.6048 3.14022 23.9147 3.18188C25.4746 3.3916 26.7371 3.83348 27.7328 4.82916C28.7285 5.82484 29.1704 7.0874 29.3801 8.64728C29.5839 10.163 29.5838 12.0996 29.5838 14.5447V17.3559C29.5838 19.8009 29.5839 21.7377 29.3801 23.2533C29.1704 24.8132 28.7285 26.0758 27.7328 27.0715C26.7371 28.0672 25.4746 28.509 23.9147 28.7187C22.399 28.9225 20.4623 28.9225 18.0172 28.9225H12.5452C10.1001 28.9225 8.16335 28.9225 6.64766 28.7187C5.08778 28.509 3.82522 28.0672 2.82954 27.0715C1.83385 26.0758 1.39198 24.8132 1.18226 23.2533C0.978479 21.7376 0.978495 19.801 0.978516 17.3559V14.5448C0.978495 12.0997 0.978479 10.163 1.18226 8.64728C1.39198 7.0874 1.83385 5.82484 2.82954 4.82916C3.82522 3.83348 5.08778 3.3916 6.64766 3.18188C6.95756 3.14022 7.28507 3.10707 7.63091 3.0807V1.98028C7.63091 1.42918 8.07767 0.982422 8.62877 0.982422ZM6.91358 5.15981C5.575 5.33977 4.80379 5.67728 4.24072 6.24035C3.67765 6.80342 3.34015 7.57463 3.16018 8.91321C3.1297 9.1399 3.10422 9.37856 3.08291 9.63054H27.4794C27.4581 9.37856 27.4326 9.1399 27.4022 8.91321C27.2222 7.57463 26.8847 6.80342 26.3216 6.24035C25.7585 5.67728 24.9873 5.33977 23.6488 5.15981C22.2815 4.97598 20.4791 4.97386 17.9421 4.97386H12.6202C10.0832 4.97386 8.28087 4.97598 6.91358 5.15981ZM2.97424 14.6198C2.97424 13.4836 2.97466 12.4947 2.99165 11.6263H27.5707C27.5877 12.4947 27.5881 13.4836 27.5881 14.6198V17.2808C27.5881 19.8178 27.586 21.6201 27.4022 22.9874C27.2222 24.326 26.8847 25.0972 26.3216 25.6603C25.7585 26.2234 24.9873 26.5609 23.6488 26.7408C22.2815 26.9247 20.4791 26.9268 17.9421 26.9268H12.6202C10.0832 26.9268 8.28087 26.9247 6.91358 26.7408C5.575 26.5609 4.80379 26.2234 4.24072 25.6603C3.67765 25.0972 3.34015 24.326 3.16018 22.9874C2.97635 21.6201 2.97424 19.8178 2.97424 17.2808V14.6198Z"
                                    fill="#000000"
                                  />
                                </svg>
                              </div>
                              <div className="datePickerWrap">
                                <input
                                  id="return-datepicker"
                                  value={returnDate}
                                  required={isRoundTrip}
                                  onChange={(e) =>
                                    setReturnDate(e.target.value)
                                  }
                                  placeholder="Select Date"
                                  type="text"
                                  disabled={!departureDate}
                                />
                                {errors.returnDate && (
                                  <span className="error">
                                    {errors.returnDate}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </li>
                      )}
                      <li className="sixth">
                        <div className="inputField">
                          <label>Passanger</label>
                          <div className="icoInputWrap">
                            <div className="icoWrap">
                              <svg
                                width="22"
                                height="28"
                                viewBox="0 0 22 28"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M11.28 0.113281C7.78965 0.113281 4.96019 2.94274 4.96019 6.43306C4.96019 9.92338 7.78965 12.7528 11.28 12.7528C14.7703 12.7528 17.5997 9.92338 17.5997 6.43306C17.5997 2.94274 14.7703 0.113281 11.28 0.113281ZM6.95591 6.43306C6.95591 4.04495 8.89185 2.109 11.28 2.109C13.6681 2.109 15.604 4.04495 15.604 6.43306C15.604 8.82117 13.6681 10.7571 11.28 10.7571C8.89185 10.7571 6.95591 8.82117 6.95591 6.43306Z"
                                  fill="#000000"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M11.28 14.7486C8.56667 14.7486 6.06118 15.3749 4.19935 16.4388C2.36575 17.4866 0.96875 19.0861 0.96875 21.0683C0.96875 23.0506 2.36575 24.6501 4.19935 25.6979C6.06118 26.7618 8.56667 27.3881 11.28 27.3881C13.9933 27.3881 16.4987 26.7618 18.3606 25.6979C20.1942 24.6501 21.5912 23.0506 21.5912 21.0683C21.5912 19.0861 20.1942 17.4866 18.3606 16.4388C16.4987 15.3749 13.9933 14.7486 11.28 14.7486ZM2.96447 21.0683C2.96447 20.1114 3.65234 19.0499 5.18951 18.1716C6.69845 17.3093 8.84963 16.7443 11.28 16.7443C13.7103 16.7443 15.8615 17.3093 17.3704 18.1716C18.9076 19.0499 19.5955 20.1114 19.5955 21.0683C19.5955 22.0253 18.9076 23.0867 17.3704 23.9651C15.8615 24.8274 13.7103 25.3924 11.28 25.3924C8.84963 25.3924 6.69845 24.8274 5.18951 23.9651C3.65234 23.0867 2.96447 22.0253 2.96447 21.0683Z"
                                  fill="#000000"
                                />
                              </svg>
                            </div>
                            <div className="dropdown">
                              <input
                                type="text"
                                id="passenger-selection"
                                placeholder="Select Passengers"
                                value={getDisplayText()}
                                readOnly
                                required
                                onFocus={() =>
                                  setPassengerDropdownVisible(true)
                                }
                              />
                              {errors.passengers && (
                                <span className="error">
                                  {errors.passengers}
                                </span>
                              )}
                              {passengerDropdownVisible && (
                                <div className="dropdown-menu passenger-dropdown">
                                  {/* Adults */}
                                  <div className="passenger-type">
                                    <div className="leftWrap">
                                      <svg
                                        width="12"
                                        height="25"
                                        viewBox="0 0 12 25"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M2.4 3.75C2.4 1.67893 4.01178 0 6 0C7.98823 0 9.6 1.67893 9.6 3.75C9.6 5.82107 7.98823 7.5 6 7.5C4.01178 7.5 2.4 5.82107 2.4 3.75Z"
                                          fill="#808089"
                                        />
                                        <path
                                          d="M0 12.5C0 10.4289 1.61178 8.75 3.6 8.75H8.4C10.3882 8.75 12 10.4289 12 12.5V16.7923C12 17.2313 11.7788 17.6382 11.4174 17.8641L9 19.375V23.75C9 24.4404 8.46274 25 7.8 25H4.2C3.53726 25 3 24.4404 3 23.75V19.375L0.582605 17.8641C0.221159 17.6382 0 17.2313 0 16.7923V12.5Z"
                                          fill="#808089"
                                        />
                                      </svg>
                                      <label>
                                        Adults <span>12+</span>
                                      </label>
                                    </div>
                                    <div className="counter">
                                      <button
                                        className="btn btn-minus"
                                        type="button"
                                        onClick={() =>
                                          updateCount("adults", -1)
                                        }
                                      >
                                        -
                                      </button>
                                      <span>{passengerCounts.adults}</span>
                                      <button
                                        className="btn btn-plus"
                                        type="button"
                                        onClick={() => updateCount("adults", 1)}
                                      >
                                        +
                                      </button>
                                    </div>
                                  </div>
                                  {/* Children */}
                                  <div className="passenger-type">
                                    <div className="leftWrap">
                                      <svg
                                        width="13"
                                        height="20"
                                        viewBox="0 0 13 20"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M10.5 4C10.5 6.20914 8.70914 8 6.5 8C4.29086 8 2.50001 6.20914 2.50001 4C2.50001 1.79086 4.29086 0 6.5 0C8.70914 0 10.5 1.79086 10.5 4Z"
                                          fill="#808089"
                                        />
                                        <path
                                          d="M0.3909 7.99011C0.948646 7.37757 1.89735 7.33314 2.5099 7.89089C3.63842 8.91846 5.02338 9.5 6.5 9.5C7.97662 9.5 9.36158 8.91846 10.4901 7.89089C11.1026 7.33314 12.0514 7.37757 12.6091 7.99011C13.1668 8.60265 13.1224 9.55136 12.5099 10.1091C11.7459 10.8047 10.8788 11.3753 9.93511 11.7843L11.1021 17.9113C11.3087 18.9955 10.4775 20 9.37375 20C8.56639 20 7.86263 19.4505 7.66681 18.6673L7.12127 16.4851C7.05 16.2 6.79385 16 6.5 16C6.20615 16 5.95 16.2 5.87873 16.4851L5.33319 18.6673C5.13737 19.4505 4.43361 20 3.62625 20C2.52252 20 1.69133 18.9955 1.89785 17.9113L3.06489 11.7843C2.12119 11.3753 1.25407 10.8047 0.49012 10.1091C-0.122423 9.55136 -0.166845 8.60265 0.3909 7.99011Z"
                                          fill="#808089"
                                        />
                                      </svg>
                                      <label>
                                        Children <span>2-11 Years</span>
                                      </label>
                                    </div>
                                    <div className="counter">
                                      <button
                                        className="btn btn-minus"
                                        type="button"
                                        onClick={() =>
                                          updateCount("children", -1)
                                        }
                                      >
                                        -
                                      </button>
                                      <span>{passengerCounts.children}</span>
                                      <button
                                        className="btn btn-plus"
                                        type="button"
                                        onClick={() =>
                                          updateCount("children", 1)
                                        }
                                      >
                                        +
                                      </button>
                                    </div>
                                  </div>
                                  {/* Child Age Inputs */}
                                  {passengerCounts.children > 0 && (
                                    <div className="child-age-inputs">
                                      {childrenAges.map((age, index) => (
                                        <input
                                          key={index}
                                          type="number"
                                          min="2"
                                          max="11"
                                          placeholder={`Age of child ${
                                            index + 1
                                          }`}
                                          value={age}
                                          onChange={(e) =>
                                            handleChildAgeChange(
                                              index,
                                              e.target.value
                                            )
                                          }
                                        />
                                      ))}
                                    </div>
                                  )}
                                  {/* Infants */}
                                  <div className="passenger-type marBtm0">
                                    <div className="leftWrap">
                                      <svg
                                        width="13"
                                        height="21"
                                        viewBox="0 0 13 21"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M10.5 4.2C10.5 6.5196 8.70914 8.4 6.5 8.4C4.29086 8.4 2.50001 6.5196 2.50001 4.2C2.50001 1.8804 4.29086 0 6.5 0C8.70914 0 10.5 1.8804 10.5 4.2Z"
                                          fill="#808089"
                                        />
                                        <path
                                          d="M0.3909 8.38962C0.948646 7.74644 1.89735 7.6998 2.5099 8.28543C3.63842 9.36439 5.02338 9.975 6.5 9.975C7.97662 9.975 9.36158 9.36439 10.4901 8.28543C11.1026 7.6998 12.0514 7.74644 12.6091 8.38962C13.1668 9.03279 13.1224 10.0289 12.5099 10.6146C11.7459 11.345 10.8788 11.944 9.93511 12.3736L11.1021 18.8069C11.3087 19.9453 10.4775 21 9.37375 21C8.56639 21 7.86263 20.423 7.66681 19.6006L7.12127 17.3093C7.05 17.01 6.79385 16.8 6.5 16.8C6.20615 16.8 5.95 17.01 5.87873 17.3093L5.33319 19.6006C5.13737 20.423 4.43361 21 3.62625 21C2.52252 21 1.69133 19.9453 1.89785 18.8069L3.06489 12.3736C2.12119 11.944 1.25407 11.345 0.49012 10.6146C-0.122423 10.0289 -0.166845 9.03279 0.3909 8.38962Z"
                                          fill="#808089"
                                        />
                                      </svg>
                                      <label>
                                        Infants <span>2 Years</span>
                                      </label>
                                    </div>
                                    <div className="counter">
                                      <button
                                        className="btn btn-minus"
                                        type="button"
                                        onClick={() =>
                                          updateCount("infants", -1)
                                        }
                                      >
                                        -
                                      </button>
                                      <span>{passengerCounts.infants}</span>
                                      <button
                                        className="btn btn-plus"
                                        type="button"
                                        onClick={() =>
                                          updateCount("infants", 1)
                                        }
                                      >
                                        +
                                      </button>
                                    </div>
                                  </div>
                                  {/* Clear All */}
                                  <div className="ctaClrWrap">
                                    <button className="btn" onClick={clearAll}>
                                      Clear all
                                    </button>
                                    <button
                                      className="btn btn-save"
                                      onClick={saveSelection}
                                    >
                                      Save
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </li>
                      <li className="sixth">
                        <div className="inputField">
                          <label>Seat Class</label>
                          <div className="icoInputWrap">
                            <div className="icoWrap">
                              <svg
                                width="29"
                                height="28"
                                viewBox="0 0 29 28"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M17.8247 16.4093H10.8397C10.7662 16.4104 10.6945 16.3876 10.6351 16.3444C10.5757 16.3013 10.5319 16.24 10.5104 16.1698L9.98149 14.4136H15.829C16.0936 14.4136 16.3474 14.3085 16.5345 14.1213C16.7217 13.9342 16.8268 13.6804 16.8268 13.4157C16.8268 13.1511 16.7217 12.8973 16.5345 12.7101C16.3474 12.523 16.0936 12.4179 15.829 12.4179H9.38278L7.84607 7.27889V4.93391C7.84607 4.00764 7.47811 3.11931 6.82314 2.46434C6.16817 1.80937 5.27984 1.44141 4.35357 1.44141C3.4273 1.44141 2.53896 1.80937 1.88399 2.46434C1.22902 3.11931 0.861058 4.00764 0.861058 4.93391V7.42856C0.845793 7.51772 0.845793 7.60883 0.861058 7.69799L4.5731 20.6702C4.71083 21.1674 5.00807 21.6057 5.41911 21.9175C5.83015 22.2294 6.33224 22.3977 6.84821 22.3965H7.35712L5.92021 26.0187C5.85989 26.1701 5.83759 26.3341 5.85528 26.4961C5.87296 26.6582 5.93008 26.8135 6.02164 26.9483C6.11321 27.0832 6.23642 27.1936 6.38052 27.2699C6.52461 27.3461 6.68519 27.3859 6.84821 27.3858H16.8268C16.9898 27.3859 17.1504 27.3461 17.2945 27.2699C17.4386 27.1936 17.5618 27.0832 17.6534 26.9483C17.7449 26.8135 17.8021 26.6582 17.8197 26.4961C17.8374 26.3341 17.8151 26.1701 17.7548 26.0187L16.3079 22.3965H17.8247C18.6186 22.3965 19.38 22.0811 19.9415 21.5197C20.5029 20.9583 20.8182 20.1968 20.8182 19.4029C20.8182 18.6089 20.5029 17.8475 19.9415 17.2861C19.38 16.7247 18.6186 16.4093 17.8247 16.4093ZM3.18607 8.42642H6.1098L7.30723 12.4179H4.31365L3.18607 8.42642ZM4.35357 3.43713C4.75054 3.43713 5.13125 3.59482 5.41196 3.87552C5.69266 4.15623 5.85036 4.53694 5.85036 4.93391V6.4307H2.85678V4.93391C2.85678 4.53694 3.01447 4.15623 3.29518 3.87552C3.57588 3.59482 3.95659 3.43713 4.35357 3.43713ZM15.33 25.39H8.345L9.54244 22.3965H14.1725L15.33 25.39ZM17.8247 20.4007H6.84821C6.77393 20.3996 6.70195 20.3748 6.64273 20.3299C6.58351 20.2851 6.54014 20.2225 6.51892 20.1513L4.8525 14.4136H7.84607L8.54458 16.7386C8.68817 17.2315 8.99157 17.6628 9.40704 17.9644C9.82251 18.2661 10.3265 18.4211 10.8397 18.405H17.8247C18.0893 18.405 18.3431 18.5102 18.5303 18.6973C18.7174 18.8844 18.8225 19.1382 18.8225 19.4029C18.8225 19.6675 18.7174 19.9213 18.5303 20.1085C18.3431 20.2956 18.0893 20.4007 17.8247 20.4007Z"
                                  fill="#000000"
                                />
                                <path
                                  d="M25.488 0.443359H22.1352C21.2565 0.443359 20.4139 0.792395 19.7926 1.41368C19.1713 2.03497 18.8223 2.87762 18.8223 3.75625V10.1026C18.8223 10.9813 19.1713 11.8239 19.7926 12.4452C20.4139 13.0665 21.2565 13.4155 22.1352 13.4155H25.488C26.3666 13.4155 27.2092 13.0665 27.8305 12.4452C28.4518 11.8239 28.8009 10.9813 28.8009 10.1026V3.75625C28.8009 3.3212 28.7152 2.8904 28.5487 2.48846C28.3822 2.08652 28.1382 1.72131 27.8305 1.41368C27.5229 1.10605 27.1577 0.862027 26.7558 0.695538C26.3538 0.52905 25.923 0.443359 25.488 0.443359ZM22.1352 2.43908H25.488C25.8373 2.43908 26.1723 2.57785 26.4194 2.82487C26.6664 3.07189 26.8051 3.40692 26.8051 3.75625V4.4348H20.818V3.75625C20.818 3.40692 20.9568 3.07189 21.2038 2.82487C21.4508 2.57785 21.7858 2.43908 22.1352 2.43908ZM25.488 11.4198H22.1352C21.7858 11.4198 21.4508 11.281 21.2038 11.034C20.9568 10.787 20.818 10.452 20.818 10.1026V6.43052H26.8051V10.1026C26.8051 10.452 26.6664 10.787 26.4194 11.034C26.1723 11.281 25.8373 11.4198 25.488 11.4198Z"
                                  fill="#000000"
                                />
                              </svg>
                            </div>
                            <div className="dropdown">
                              <input
                                type="text"
                                id="Select-Class"
                                placeholder="Select Class"
                                value={seatClass}
                                onFocus={() => setShowDropdown(true)} // Show dropdown on focus
                                onBlur={() =>
                                  setTimeout(() => setShowDropdown(false), 150)
                                } // Hide dropdown after losing focus
                                onChange={(e) => setSeatClass(e.target.value)} // Update input field
                              />
                              {showDropdown && (
                                <ul className="dropdown-menu">
                                  {seatClassOptions.map((option, index) => (
                                    <li
                                      key={index}
                                      onClick={() => setSeatClass(option)} // Set selected option
                                    >
                                      {option}
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </div>
                          </div>
                        </div>
                      </li>
                      {isLoading && (
                        <div className="loaderWrap">
                          <div className="loader">
                            <div className="rocket"></div>
                          </div>
                          <h3>Just a moment... we will take you there</h3>
                        </div>
                      )}
                      <li className="full">
                        <div className="ctaWrap">
                          <a className="btn" onClick={handleSearchFlights}>
                            Search
                          </a>
                        </div>
                      </li>
                    </ul>
                  </form>
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="ctaToggleWrap">
                  <button
                    className="btn"
                    id="toggle-btn"
                    onClick={handleToggle}
                  >
                    <svg
                      className={isClosed ? "arrow-closed" : "arrow-open"}
                      width="35"
                      height="35"
                      viewBox="0 0 35 35"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M24.8333 17.5L17.5 10.1667M17.5 10.1667L17.5 24.8333M17.5 10.1667L10.1667 17.5M34 17.5C34 15.3332 33.5732 13.1876 32.744 11.1857C31.9148 9.18385 30.6994 7.36491 29.1673 5.83274C27.6351 4.30058 25.8162 3.08519 23.8143 2.25599C21.8124 1.42679 19.6668 1 17.5 1C15.3332 1 13.1876 1.42679 11.1857 2.25599C9.18385 3.08519 7.36491 4.30057 5.83274 5.83274C4.30057 7.36491 3.08519 9.18385 2.25599 11.1857C1.42678 13.1876 0.999999 15.3332 0.999999 17.5C0.999998 21.8761 2.73839 26.0729 5.83274 29.1673C8.92709 32.2616 13.1239 34 17.5 34C21.8761 34 26.0729 32.2616 29.1673 29.1673C32.2616 26.0729 34 21.8761 34 17.5Z"
                        stroke="#5D5D5D"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flightListWrap depReturnFlightListWrap">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="mobFilterWrap">
                  <button
                    className="btn"
                    id="mobFilterBtn"
                    onClick={toggleRightPanel}
                  >
                    Filter
                  </button>
                </div>
                <div className="row">
                  <ul className="nav nav-tabs d-lg-none">
                    <li className="nav-item">
                      <button
                        className={`nav-link ${
                          activeTab === "tab1" ? "active" : ""
                        }`}
                        onClick={() => setActiveTab("tab1")}
                      >
                        Departure
                      </button>
                    </li>
                    {isRoundTrip && (
                      <li className="nav-item">
                        <button
                          className={`nav-link ${
                            activeTab === "tab2" ? "active" : ""
                          }`}
                          onClick={() => setActiveTab("tab2")}
                        >
                          Return
                        </button>
                      </li>
                    )}
                  </ul>
                  <div
                    className={`${
                      windowWidth >= 992
                        ? "col-md-6" // Use col-md-6 for desktop
                        : activeTab === "tab1"
                        ? "col-md-12" // Use col-md-12 for active tab on mobile
                        : "d-none" // Hide inactive tab on mobile
                    } padRight0`}
                  >
                    <div className="datePriceWrap">
                      <div className="slider-container">
                        {/* {dates.length > 0 && (
  <Slider {...sliderSettings} ref={sliderRef}>
    {dates.map((date, index) => {
      // Highlight the searched date
      const isSearchedDate = departureDate === date.formattedDate;
      
      return (
        <div
          key={date.id}
          className={`date-item ${
            date.isActive ? "current-date" : ""
          } ${index === activeIndex ? "active" : ""} ${
            isSearchedDate ? "searched-date" : ""
          }`}
          onClick={() => handleDateClick(index)}
        >
          <p className="date">{date.date}</p>
          <h3
  className="price"
  style={{
    color: (loadingDates.includes(date.formattedDate) || !date.price) ? "blue" : "inherit",
    fontSize: (loadingDates.includes(date.formattedDate) || !date.price) ? "12px" : "inherit",
  }}
>
  {loadingDates.includes(date.formattedDate)
    ? "Loading..."
    : (date.price || "Click to load")}
</h3>
          {isSearchedDate && <div className="searched-badge"></div>}
        </div>
      );
    })}
  </Slider>
)} */}
                      </div>
                    </div>
                    <div className="noFlightAvilabe">
                      <h6>{/* {selectedFromIATA} - {selectedToIATA} */}</h6>
                      <p>{flights.length} Flights Available</p>
                    </div>
                    <div className="flightListTabWrap">
                      <div className="sortTTl">
                        <h3>Sort By</h3>
                      </div>
                      <ul
                        className="nav nav-pills"
                        id="pills-tab"
                        role="tablist"
                      >
                        <li className="nav-item" role="presentation">
                          <button
                            className={`nav-link ${
                              departureSort === "recommended" ? "active" : ""
                            }`}
                            onClick={() =>
                              handleDepartureSortChange("recommended")
                            }
                            id="pills-Recommended-tab1"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-Recommended"
                            type="button"
                            role="tab"
                            aria-controls="pills-Recommended"
                            aria-selected="true"
                          >
                            <div className="icoWrap">
                              <img
                                src={Ico1}
                                className="img-fluid icoNoActive"
                                alt=""
                              />
                              <img
                                src={IcoActive1}
                                className="img-fluid icoActive"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Recommended</h2>
                              <p>
                                {" "}
                                {
                                  getDepartureSortInfo("recommended").price
                                } -{" "}
                                {getDepartureSortInfo("recommended").duration}
                              </p>
                            </div>
                          </button>
                        </li>
                        <li className="nav-item" role="presentation">
                          <button
                            className={`nav-link ${
                              departureSort === "fastest" ? "active" : ""
                            }`}
                            onClick={() => handleDepartureSortChange("fastest")}
                            id="pills-Fastest-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-Fastest"
                            type="button"
                            role="tab"
                            aria-controls="pills-Fastest"
                            aria-selected="false"
                          >
                            <div className="icoWrap">
                              <img
                                src={Ico2}
                                className="img-fluid icoNoActive"
                                alt=""
                              />
                              <img
                                src={IcoActive2}
                                className="img-fluid icoActive"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Fastest</h2>
                              <p>
                                {" "}
                                {getDepartureSortInfo("fastest").price} -{" "}
                                {getDepartureSortInfo("fastest").duration}
                              </p>
                            </div>
                          </button>
                        </li>
                        <li className="nav-item" role="presentation">
                          <button
                            className={`nav-link ${
                              departureSort === "cheapest" ? "active" : ""
                            }`}
                            onClick={() =>
                              handleDepartureSortChange("cheapest")
                            }
                            id="pills-Cheapest-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-Cheapest"
                            type="button"
                            role="tab"
                            aria-controls="pills-Cheapest"
                            aria-selected="false"
                          >
                            <div className="icoWrap">
                              <img
                                src={Ico3}
                                className="img-fluid icoNoActive"
                                alt=""
                              />
                              <img
                                src={IcoActive3}
                                className="img-fluid icoActive"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Cheapest</h2>
                              <p>
                                {" "}
                                {getDepartureSortInfo("cheapest").price} -{" "}
                                {getDepartureSortInfo("cheapest").duration}
                              </p>
                            </div>
                          </button>
                        </li>
                      </ul>
                      <div className="tab-content" id="pills-tabContent">
                        <div
                          className="tab-pane fade show active"
                          id="pills-Recommended1"
                          role="tabpanel"
                          aria-labelledby="pills-home-tab"
                        >
                          <ul>
                            {/* {flights.map((flight, index) => {
                              const returnData = flight.Directions?.[0]?.[0];
                              const direction = flight.Directions?.[0]?.[0];
                              //const segment = direction?.Segments?.[0];
                              const segments = direction.Segments;
                              const stops = segments.length - 1;
                              const convertedPrice = convertedPrices[index];
                              const layovers = [];
                              for (let i = 0; i < segments.length - 1; i++) {
                                const arrival = new Date(segments[i].Arrival);
                                const departure = new Date(
                                  segments[i + 1].Departure
                                );
                                const layoverMs = departure - arrival;
                                const hours = Math.floor(
                                  layoverMs / (1000 * 60 * 60)
                                );
                                const minutes = Math.floor(
                                  (layoverMs % (1000 * 60 * 60)) / (1000 * 60)
                                );
                                layovers.push(`${hours}h ${minutes}m`);
                              }

                              const bookingInfo = flight.BookingComponent;
                              const isSelected =
                                selectedFlight?.index === index; */}
                            {departureFlights.map((flight, index) => {
                              const direction = flight.Directions?.[0]?.[0];
                              if (!direction) return null;

                              const segments = direction.Segments;
                              const stops = segments.length - 1;
                              const layovers = calculateLayovers(segments);
                              const bookingInfo = flight.BookingComponent;
                              const isSelected =
                                selectedFlight?.index === index;
                              return (
                                <li key={flight.UniqueTransID}>
                                  <div
                                    className={`itemWrap ${
                                      isSelected ? "active" : ""
                                    }`}
                                  >
                                    <div className="topWrap">
                                      <div className="leftWrap">
                                        <div className="icoWrap">
                                          <img
                                            src={airlineImg}
                                            className="img-fluid"
                                            alt=""
                                          />
                                        </div>
                                        <h2>{direction.PlatingCarrierName}</h2>
                                      </div>
                                      <div className="midSecWrap">
                                        <div className="leftWrap">
                                          {/* {new Date(segment.Arrival).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}  */}

                                          <ul>
                                            <li>
                                              <div className="items">
                                                <span>
                                                  {formatDateWithWeekday(
                                                    segments[0].Departure
                                                  )}
                                                </span>
                                                <h3>
                                                  {segments[0].Departure.split(
                                                    " "
                                                  )[1].slice(0, 5)}
                                                </h3>
                                                <p>
                                                  {getCityByIata(
                                                    direction.Origin
                                                  )}
                                                  ({direction.Origin})
                                                </p>
                                              </div>
                                            </li>
                                            <li>
                                              <div className="items">
                                                <h4>
                                                  {direction.DirectionTotalTime}
                                                </h4>
                                                {/* <div className="planeIcoWrap">
                                                  <img
                                                    src={PlaneIco}
                                                    className="img-fluid"
                                                    alt=""
                                                  />
                                                  {stops > 0 && (
                                                    <div className="stop-dots">
                                                      {Array(stops)
                                                        .fill()
                                                        .map((_, i) => (
                                                          <div
                                                            key={i}
                                                            className="stop-dot"
                                                            data-tooltip={`Layover at ${getCityByIata(
                                                              segments[i]
                                                                .Destination
                                                            )}: ${layovers[i]}`}
                                                          >
                                                            <div className="dot">
                                                              <img
                                                                src={
                                                                  StopPlaneImg
                                                                }
                                                                className="img-fluid"
                                                                alt=""
                                                              />
                                                            </div>
                                                            <div className="stop-info">
                                                              {getCityByIata(
                                                                segments[i]
                                                                  .Destination
                                                              )}{" "}
                                                              (
                                                              {
                                                                segments[i]
                                                                  .Destination
                                                              }
                                                              )<br />
                                                              Layover:{" "}
                                                              {layovers[i]}
                                                            </div>
                                                          </div>
                                                        ))}
                                                    </div>
                                                  )}
                                                </div> */}
                                                <div className="planeIcoWrap">
                                                  {stops === 0 ? (
                                                    <img
                                                      src={PlaneIco}
                                                      className="img-fluid"
                                                      alt=""
                                                    />
                                                  ) : (
                                                    <div className="stop-dots">
                                                      {Array(stops)
                                                        .fill()
                                                        .map((_, i) => (
                                                          <div
                                                            key={i}
                                                            className="stop-dot"
                                                            data-tooltip={`Layover at ${getCityByIata(
                                                              segments[i]
                                                                .Destination
                                                            )}: ${layovers[i]}`}
                                                          >
                                                            <div className="dot">
                                                              <img
                                                                src={
                                                                  StopPlaneImg
                                                                }
                                                                className="img-fluid"
                                                                alt=""
                                                              />
                                                            </div>
                                                            <div className="stop-info">
                                                              {getCityByIata(
                                                                segments[i]
                                                                  .Destination
                                                              )}{" "}
                                                              (
                                                              {
                                                                segments[i]
                                                                  .Destination
                                                              }
                                                              )<br />
                                                              Layover:{" "}
                                                              {layovers[i]}
                                                            </div>
                                                          </div>
                                                        ))}
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                            </li>
                                            <li>
                                              <div className="items">
                                                <span>
                                                  {formatDateWithWeekday(
                                                    segments[
                                                      segments.length - 1
                                                    ].Arrival
                                                  )}
                                                </span>

                                                <h3>
                                                  {segments[
                                                    segments.length - 1
                                                  ].Arrival.split(" ")[1].slice(
                                                    0,
                                                    5
                                                  )}
                                                </h3>
                                                <p>
                                                  {getCityByIata(
                                                    direction.Destination
                                                  )}
                                                  ({direction.Destination})
                                                </p>
                                              </div>
                                            </li>
                                          </ul>
                                        </div>
                                        <div className="rightWrap">
                                          <p>
                                            Travel Class:{" "}
                                            <span>
                                              {segments[0].ServiceClass}
                                            </span>
                                          </p>
                                          <h2>
                                            {selectedCurrency}{" "}
                                            {convertedPrices[index] !==
                                            undefined
                                              ? convertedPrices[index]
                                              : convertedPrices[0] !== undefined
                                              ? convertedPrices[0]
                                              : "Loading..."}
                                          </h2>
                                          {/* ? convertedPrices
                                          : "Loading..."}</h2> */}
                                          {/* <!-- <button className="btn">Book Now</button> --> */}
                                          <button
                                            className={`btnBook ${
                                              isSelected ? "selected" : ""
                                            }`}
                                            onClick={() => {
                                              if (isSelected) {
                                                setSelectedFlight(null);
                                              } else {
                                                setSelectedFlight({
                                                  ...flight,
                                                  index,
                                                });
                                              }
                                            }}
                                          >
                                            {isSelected ? "Selected" : "Select"}
                                          </button>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="btmWrap">
                                      <p>
                                        {/* {segments.BookingCount} seats remaining */}
                                      </p>
                                      <p className="clrTxt">
                                        {flight.Refundable
                                          ? "Refundable"
                                          : "Non-Refundable"}
                                      </p>
                                      <Link to="" className="clrTxt weightTxt">
                                        {/* View flight details */}
                                      </Link>
                                    </div>
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`${
                      windowWidth >= 992
                        ? "col-md-6" // Use col-md-6 for desktop
                        : activeTab === "tab2"
                        ? "col-md-12" // Use col-md-12 for active tab on mobile
                        : "d-none" // Hide inactive tab on mobile
                    } padLeft0`}
                  >
                    <div className="datePriceWrap">
                      <div className="slider-container">
                        {/* {dates.length > 0 && (
  <Slider {...sliderSettings} ref={sliderRef}>
    {dates.map((date, index) => {
      // Highlight the searched date
      const isSearchedDate = departureDate === date.formattedDate;
      
      return (
        <div
          key={date.id}
          className={`date-item ${
            date.isActive ? "current-date" : ""
          } ${index === activeIndex ? "active" : ""} ${
            isSearchedDate ? "searched-date" : ""
          }`}
          onClick={() => handleDateClick(index)}
        >
          <p className="date">{date.date}</p>
          <h3
  className="price"
  style={{
    color: (loadingDates.includes(date.formattedDate) || !date.price) ? "blue" : "inherit",
    fontSize: (loadingDates.includes(date.formattedDate) || !date.price) ? "12px" : "inherit",
  }}
>
  {loadingDates.includes(date.formattedDate)
    ? "Loading..."
    : (date.price || "Click to load")}
</h3>
          {isSearchedDate && <div className="searched-badge"></div>}
        </div>
      );
    })}
  </Slider>
)} */}
                      </div>
                    </div>
                    <div className="noFlightAvilabe">
                      <h6>{/* {selectedToIATA} - {selectedFromIATA} */}</h6>
                      <p>{flights.length} Flights Available</p>
                    </div>
                    <div className="flightListTabWrap">
                      <div className="sortTTl">
                        <h3>Sort By</h3>
                      </div>
                      <ul
                        className="nav nav-pills"
                        id="pills-tab"
                        role="tablist"
                      >
                        <li className="nav-item" role="presentation">
                          <button
                            className={`nav-link ${
                              returnSort === "recommended" ? "active" : ""
                            }`}
                            onClick={() =>
                              handleReturnSortChange("recommended")
                            }
                            id="pills-Recommended-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-Recommended"
                            type="button"
                            role="tab"
                            aria-controls="pills-Recommended"
                            aria-selected="true"
                          >
                            <div className="icoWrap">
                              <img
                                src={Ico1}
                                className="img-fluid icoNoActive"
                                alt=""
                              />
                              <img
                                src={IcoActive1}
                                className="img-fluid icoActive"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Recommended</h2>
                              <p>
                                {getReturnSortInfo("recommended").price} -{" "}
                                {getReturnSortInfo("recommended").duration}
                              </p>
                            </div>
                          </button>
                        </li>
                        <li className="nav-item" role="presentation">
                          <button
                            className={`nav-link ${
                              returnSort === "fastest" ? "active" : ""
                            }`}
                            onClick={() => handleReturnSortChange("fastest")}
                            id="pills-Fastest-tab1"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-Fastest"
                            type="button"
                            role="tab"
                            aria-controls="pills-Fastest"
                            aria-selected="false"
                          >
                            <div className="icoWrap">
                              <img
                                src={Ico2}
                                className="img-fluid icoNoActive"
                                alt=""
                              />
                              <img
                                src={IcoActive2}
                                className="img-fluid icoActive"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Fastest</h2>
                              <p>
                                {" "}
                                {getReturnSortInfo("fastest").price} -{" "}
                                {getReturnSortInfo("fastest").duration}
                              </p>
                            </div>
                          </button>
                        </li>
                        <li className="nav-item" role="presentation">
                          <button
                            className={`nav-link ${
                              returnSort === "cheapest" ? "active" : ""
                            }`}
                            onClick={() => handleReturnSortChange("cheapest")}
                            id="pills-Cheapest-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-Cheapest"
                            type="button"
                            role="tab"
                            aria-controls="pills-Cheapest"
                            aria-selected="false"
                          >
                            <div className="icoWrap">
                              <img
                                src={Ico3}
                                className="img-fluid icoNoActive"
                                alt=""
                              />
                              <img
                                src={IcoActive3}
                                className="img-fluid icoActive"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <h2>Cheapest</h2>
                              <p>
                                {" "}
                                {getReturnSortInfo("cheapest").price} -{" "}
                                {getReturnSortInfo("cheapest").duration}
                              </p>
                            </div>
                          </button>
                        </li>
                      </ul>
                      <div className="tab-content" id="pills-tabContent">
                        <div
                          className="tab-pane fade show active"
                          id="pills-Recommended1"
                          role="tabpanel"
                          aria-labelledby="pills-home-tab"
                        >
                          <ul>
                            {returnFlights.map((flight, index) => {
                              const direction = flight.Directions?.[1]?.[0];
                              if (!direction) return null;
                              const segments = direction.Segments;
                              const stops = segments.length - 1;
                              const layovers = calculateLayovers(segments);
                              const bookingInfo = flight.BookingComponent;
                              const isSelected =
                                selectedReturnFlight?.index === index;
                              return (
                                <li key={`return-${flight.UniqueTransID}`}>
                                  <div
                                    className={`itemWrap ${
                                      isSelected ? "active" : ""
                                    }`}
                                  >
                                    <div className="topWrap">
                                      <div className="leftWrap">
                                        <div className="icoWrap">
                                          <img
                                            src={airlineImg}
                                            className="img-fluid"
                                            alt=""
                                          />
                                        </div>
                                        <h2>{direction.PlatingCarrierName}</h2>
                                      </div>
                                      <div className="midSecWrap">
                                        <div className="leftWrap">
                                          <ul>
                                            <li>
                                              <div className="items">
                                                <span>
                                                  {formatDateWithWeekday(
                                                    segments[0].Departure
                                                  )}
                                                </span>
                                                <h3>
                                                  {segments[0].Departure.split(
                                                    " "
                                                  )[1].slice(0, 5)}
                                                </h3>
                                                <p>
                                                  {getCityByIata(
                                                    direction.Origin
                                                  )}
                                                  ({direction.Origin})
                                                </p>
                                              </div>
                                            </li>
                                            <li>
                                              <div className="items">
                                                <h4>
                                                  {direction.DirectionTotalTime}
                                                </h4>

                                                {/* <div className="planeIcoWrap">
                                                  <img
                                                    src={PlaneIco}
                                                    className="img-fluid"
                                                    alt=""
                                                  />
                                                  {stops > 0 && (
                                                    <div className="stop-dots">
                                                      {Array(stops)
                                                        .fill()
                                                        .map((_, i) => (
                                                          <div
                                                            key={i}
                                                            className="stop-dot"
                                                            data-tooltip={`Layover at ${getCityByIata(
                                                              segments[i]
                                                                .Destination
                                                            )}: ${layovers[i]}`}
                                                          >
                                                            <div className="dot"></div>
                                                            <div className="stop-info">
                                                              {getCityByIata(
                                                                segments[i]
                                                                  .Destination
                                                              )}{" "}
                                                              (
                                                              {
                                                                segments[i]
                                                                  .Destination
                                                              }
                                                              )<br />
                                                              Layover:{" "}
                                                              {layovers[i]}
                                                            </div>
                                                          </div>
                                                        ))}
                                                    </div>
                                                  )}
                                                </div> */}
                                                <div className="planeIcoWrap">
                                                  {stops === 0 ? (
                                                    <img
                                                      src={PlaneIco}
                                                      className="img-fluid"
                                                      alt=""
                                                    />
                                                  ) : (
                                                    <div className="stop-dots">
                                                      {Array(stops)
                                                        .fill()
                                                        .map((_, i) => (
                                                          <div
                                                            key={i}
                                                            className="stop-dot"
                                                            data-tooltip={`Layover at ${getCityByIata(
                                                              segments[i]
                                                                .Destination
                                                            )}: ${layovers[i]}`}
                                                          >
                                                            <div className="dot">
                                                              <img
                                                                src={
                                                                  StopPlaneImg
                                                                }
                                                                className="img-fluid"
                                                                alt=""
                                                              />
                                                            </div>
                                                            <div className="stop-info">
                                                              {getCityByIata(
                                                                segments[i]
                                                                  .Destination
                                                              )}{" "}
                                                              (
                                                              {
                                                                segments[i]
                                                                  .Destination
                                                              }
                                                              )<br />
                                                              Layover:{" "}
                                                              {layovers[i]}
                                                            </div>
                                                          </div>
                                                        ))}
                                                    </div>
                                                  )}
                                                </div>
                                              </div>
                                            </li>
                                            <li>
                                              <div className="items">
                                                <span>
                                                  {formatDateWithWeekday(
                                                    segments[
                                                      segments.length - 1
                                                    ].Arrival
                                                  )}
                                                </span>
                                                <h3>
                                                  {segments[
                                                    segments.length - 1
                                                  ].Arrival.split(" ")[1].slice(
                                                    0,
                                                    5
                                                  )}
                                                </h3>
                                                <p>
                                                  {getCityByIata(
                                                    direction.Destination
                                                  )}
                                                  ({direction.Destination})
                                                </p>
                                              </div>
                                            </li>
                                          </ul>
                                        </div>
                                        <div className="rightWrap">
                                          <p>
                                            Travel Class:{" "}
                                            <span>
                                              {segments[0].ServiceClass}
                                            </span>
                                          </p>
                                          <h2>
                                            {selectedCurrency}{" "}
                                            {convertedPrices[index] !==
                                            undefined
                                              ? convertedPrices[index]
                                              : convertedPrices[0] !== undefined
                                              ? convertedPrices[0]
                                              : "Loading..."}
                                          </h2>
                                          {/* <!-- <button className="btn">Book Now</button> --> */}
                                          {/* <Link to="/FlightReservationOne" className="btnBook">Book Now</Link> */}
                                          <button
                                            className={`btnBook ${
                                              isSelected ? "selected" : ""
                                            }`}
                                            onClick={() => {
                                              if (isSelected) {
                                                setSelectedReturnFlight(null);
                                              } else {
                                                setSelectedReturnFlight({
                                                  ...flight,
                                                  index,
                                                });
                                              }
                                            }}
                                          >
                                            {isSelected ? "Selected" : "Select"}
                                          </button>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="btmWrap">
                                      <p>
                                        {/* {segments[0].BookingCount} seats remaining */}
                                      </p>
                                      <p className="clrTxt">
                                        {flight.Refundable
                                          ? "Refundable"
                                          : "Non-Refundable"}
                                      </p>
                                      <Link to="" className="clrTxt weightTxt">
                                        {/* View flight details */}
                                      </Link>
                                    </div>
                                  </div>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div
                  className={`rightPannelWrap ${
                    isPanelVisible ? "visible" : ""
                  }`}
                  id="rightPannel"
                >
                  <button
                    className="close-btn"
                    id="closeBtn"
                    onClick={toggleRightPanel}
                  >
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 15 15"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 1L13.5 13.5"
                        stroke="#003DF6"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                      <path
                        d="M13.917 1L1.41699 13.5"
                        stroke="#003DF6"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                    </svg>
                  </button>
                  <div className="filtersWrap">
                    <div className="topFilterTTlWrap">
                      <h2>Filter By</h2>
                    </div>
                    <div className="fromStopWrap">
                      <ul>
                        <li>
                          <h5>Stop</h5>
                          <h5>From</h5>
                        </li>
                        <li>
                          <div className="checkBoxWrap">
                            <input type="checkbox" id="Nonstop" />
                            <label for="Nonstop">Nonstop(23)</label>
                          </div>
                          <p>$110</p>
                        </li>
                        <li>
                          <div className="checkBoxWrap">
                            <input type="checkbox" id="Stop1" />
                            <label for="Stop1">1 Stop (4)</label>
                          </div>
                          <p>$324</p>
                        </li>
                        <li>
                          <div className="checkBoxWrap">
                            <input type="checkbox" id="Stop2" />
                            <label for="Stop2">2+ Stops (2)</label>
                          </div>
                          <p>$349</p>
                        </li>
                      </ul>
                    </div>
                    <div className="priceSliderWrap">
                      <h2>Price</h2>
                      <div className="slider-wrapper slider-gaia">
                        <input ref={sliderRef} id="priceRange" type="text" />
                      </div>
                    </div>
                    <div className="fromStopWrap">
                      <h2>Refundable Flights </h2>
                      <ul>
                        <li>
                          <div className="checkBoxWrap">
                            <input type="checkbox" id="AnyFlight" />
                            <label for="AnyFlight">Any Flight</label>
                          </div>
                        </li>
                        <li>
                          <div className="checkBoxWrap">
                            <input type="checkbox" id="Refundable" />
                            <label for="Refundable">Refundable</label>
                          </div>
                        </li>
                        <li>
                          <div className="checkBoxWrap">
                            <input type="checkbox" id="FullyRefundable" />
                            <label for="FullyRefundable">
                              Fully Refundable
                            </label>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div className="filterFrmWrap">
                      <h2>Departure From</h2>
                      <ul>
                        <li>
                          <div className="itemWrap">
                            <div className="imgWrap">
                              <img
                                src={EarlyMorning}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <p>Early morning</p>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="itemWrap">
                            <div className="imgWrap">
                              <img
                                src={MorningIco}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <p>Morning</p>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="itemWrap">
                            <div className="imgWrap">
                              <img
                                src={AfternoonIco}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <p>Afternoon</p>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="itemWrap">
                            <div className="imgWrap">
                              <img
                                src={EveningIco}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <p>Evening</p>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div className="filterFrmWrap">
                      <h2>Arrival From</h2>
                      <ul>
                        <li>
                          <div className="itemWrap">
                            <div className="imgWrap">
                              <img
                                src={EarlyMorning}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <p>Early morning</p>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="itemWrap">
                            <div className="imgWrap">
                              <img
                                src={MorningIco}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <p>Morning</p>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="itemWrap">
                            <div className="imgWrap">
                              <img
                                src={AfternoonIco}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <p>Afternoon</p>
                            </div>
                          </div>
                        </li>
                        <li>
                          <div className="itemWrap">
                            <div className="imgWrap">
                              <img
                                src={EveningIco}
                                className="img-fluid"
                                alt=""
                              />
                            </div>
                            <div className="dataWrap">
                              <p>Evening</p>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div className="fromStopWrap padBrdMar0">
                      <h2>Popular Airlines</h2>
                      <ul>
                        <li>
                          <div className="checkBoxWrap">
                            <input type="checkbox" id="ABCAirline1" />
                            <label for="ABCAirline1">ABC Airline</label>
                          </div>
                          <div className="rightImgWrap"></div>
                        </li>
                        <li>
                          <div className="checkBoxWrap">
                            <input type="checkbox" id="ABCAirline2" />
                            <label for="ABCAirline2">ABC Airline</label>
                          </div>
                          <div className="rightImgWrap"></div>
                        </li>
                        <li>
                          <div className="checkBoxWrap">
                            <input type="checkbox" id="ABCAirline3" />
                            <label for="ABCAirline3">ABC Airline</label>
                          </div>
                          <div className="rightImgWrap"></div>
                        </li>
                        <li>
                          <div className="checkBoxWrap">
                            <input type="checkbox" id="ABCAirline4" />
                            <label for="ABCAirline4">ABC Airline</label>
                          </div>
                          <div className="rightImgWrap"></div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {selectedFlight && selectedReturnFlight && (
          <div className="btmFlightListWrapFixed">
            <div className="container-fluid">
              <div className="row align-items-center">
                <div className="col-md-8">
                  <div className="leftPannelWrap">
                    <ul>
                      {selectedFlight && (
                        <li>
                          <div className="itemWrap">
                            <h5>Departure</h5>
                            <div className="itemsBtm">
                              <div className="icoWrap">
                                <img
                                  src={PlaneIco2}
                                  className="img-fluid"
                                  alt="Departure"
                                />
                              </div>
                              <div className="dataWrap">
                                <h3>
                                  {getCityByIata(
                                    selectedFlight.Directions[0][0].Origin
                                  )}{" "}
                                  ({selectedFlight.Directions[0][0].Origin}) →{" "}
                                  {getCityByIata(
                                    selectedFlight.Directions[0][0].Destination
                                  )}{" "}
                                  ({selectedFlight.Directions[0][0].Destination}
                                  )
                                </h3>
                                <p>
                                  {formatDateWithWeekday(
                                    selectedFlight.Directions[0][0].Segments[0]
                                      .Departure
                                  )}{" "}
                                  •{" "}
                                  {selectedFlight.Directions[0][0].Segments
                                    .length === 1
                                    ? "Non stop"
                                    : `${
                                        selectedFlight.Directions[0][0].Segments
                                          .length - 1
                                      } stop(s)`}{" "}
                                  •{" "}
                                  {
                                    selectedFlight.Directions[0][0]
                                      .DirectionTotalTime
                                  }
                                </p>
                              </div>
                            </div>
                          </div>
                        </li>
                      )}
                      {/* Return Flight - only if selected */}
                      {selectedReturnFlight && (
                        <li>
                          <div className="itemWrap">
                            <h5>Return</h5>
                            <div className="itemsBtm">
                              <div className="icoWrap">
                                <img
                                  src={PlaneIco3}
                                  className="img-fluid"
                                  alt="Return"
                                />
                              </div>
                              <div className="dataWrap">
                                <h3>
                                  {getCityByIata(
                                    selectedReturnFlight.Directions[1][0].Origin
                                  )}{" "}
                                  (
                                  {selectedReturnFlight.Directions[1][0].Origin}
                                  ) →{" "}
                                  {getCityByIata(
                                    selectedReturnFlight.Directions[1][0]
                                      .Destination
                                  )}{" "}
                                  (
                                  {
                                    selectedReturnFlight.Directions[1][0]
                                      .Destination
                                  }
                                  )
                                </h3>
                                <p>
                                  {formatDateWithWeekday(
                                    selectedReturnFlight.Directions[1][0]
                                      .Segments[0].Departure
                                  )}{" "}
                                  •{" "}
                                  {selectedReturnFlight.Directions[1][0]
                                    .Segments.length === 1
                                    ? "Non stop"
                                    : `${
                                        selectedReturnFlight.Directions[1][0]
                                          .Segments.length - 1
                                      } stop(s)`}{" "}
                                  •{" "}
                                  {
                                    selectedReturnFlight.Directions[1][0]
                                      .DirectionTotalTime
                                  }
                                </p>
                              </div>
                            </div>
                          </div>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="rightPannelWrap">
                    <h4>
                      Total Amount:
                      <span>
                        {selectedCurrency}{" "}
                        {(
                          (convertedPrices[selectedFlight?.index] || 0) +
                          (convertedPrices[selectedReturnFlight?.index] || 0)
                        ).toFixed(2)}
                      </span>
                    </h4>
                    <Link
                      to="/FlightReservationOne"
                      state={{
                        // Departure Info
                        departureSegments:
                          selectedFlight?.Directions?.[0]?.[0]?.Segments || [],
                        departureLayovers: calculateLayovers(
                          selectedFlight?.Directions?.[0]?.[0]?.Segments || []
                        ),
                        departureInfo: {
                          origin: selectedFlight?.Directions[0][0]?.Origin,
                          destination:
                            selectedFlight?.Directions[0][0]?.Destination,
                          originCity: getCityByIata(
                            selectedFlight?.Directions[0][0]?.Origin
                          ),
                          destinationCity: getCityByIata(
                            selectedFlight?.Directions[0][0]?.Destination
                          ),
                          directionTotalTime:
                            selectedFlight?.Directions[0][0]
                              ?.DirectionTotalTime,
                          airline:
                            selectedFlight?.Directions[0][0]
                              ?.PlatingCarrierName,
                          serviceClass: seatClass,
                        },

                        // Return Info
                        returnSegments:
                          selectedReturnFlight?.Directions?.[1]?.[0]
                            ?.Segments || [],
                        returnLayovers: calculateLayovers(
                          selectedReturnFlight?.Directions?.[1]?.[0]
                            ?.Segments || []
                        ),
                        returnInfo: {
                          origin:
                            selectedReturnFlight?.Directions[1][0]?.Origin,
                          destination:
                            selectedReturnFlight?.Directions[1][0]?.Destination,
                          originCity: getCityByIata(
                            selectedReturnFlight?.Directions[1][0]?.Origin
                          ),
                          destinationCity: getCityByIata(
                            selectedReturnFlight?.Directions[1][0]?.Destination
                          ),
                          directionTotalTime:
                            selectedReturnFlight?.Directions[1][0]
                              ?.DirectionTotalTime,
                          airline:
                            selectedReturnFlight?.Directions[1][0]
                              ?.PlatingCarrierName,
                          serviceClass: seatClass,
                        },

                        priceDetails: {
                          BasePrice:
                            selectedFlight?.BookingComponent?.BasePrice || 0,
                          Taxes:
                            (selectedFlight?.BookingComponent?.Taxes || 0) +
                            (selectedReturnFlight?.BookingComponent?.Taxes ||
                              0),
                          TotalPrice:
                            (selectedFlight?.BookingComponent?.TotalPrice ||
                              0) +
                            (selectedReturnFlight?.BookingComponent
                              ?.TotalPrice || 0),
                        },

                        bookingInfo: {
                          ItemCodeRef: selectedFlight?.ItemCodeRef,
                          SegmentCodeRefs: [
                            ...(
                              selectedFlight?.Directions?.[0]?.[0]?.Segments ||
                              []
                            ).map((segment) => segment.SegmentCodeRef),
                            ...(
                              selectedReturnFlight?.Directions?.[1]?.[0]
                                ?.Segments || []
                            ).map((segment) => segment.SegmentCodeRef),
                          ],
                          UniqueTransID: selectedFlight?.UniqueTransID,
                        },
                        searchData: location.state.searchData,
                        seatClass,
                      }}
                      className="btnBook"
                    >
                      <button className="btn">
                        Continue
                        <svg
                          width="6"
                          height="16"
                          viewBox="0 0 8 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1.51172 1.89062L6.94029 11.3906L1.51172 20.8906"
                            stroke="white"
                            strokeWidth="1.80952"
                            strokeLinecap="round"
                          />
                        </svg>
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer></Footer>
    </>
  );
};
export default DepartureReturnFlighs;
